webpackJsonp([1],{

/***/ "+FuK":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"quiz-step suggestion-step\"\u003E\u003Ch2\u003EThe Dollarbird promise\u003C\u002Fh2\u003E\u003Cp class=\"subtitle\"\u003ELet's help you take control of your finances in the simplest way possible.\u003C\u002Fp\u003E\u003Cdiv class=\"features-list\"\u003E\u003Cdiv class=\"feature\" ng-repeat=\"feature in $ctrl.features\"\u003E\u003Cdiv class=\"feature-icon\"\u003E\u003Ci class=\"icon\" ng-class=\"'icon-dollarbird-' + feature.icon\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"feature-content\"\u003E\u003Ch3\u003E{{feature.title}}\u003C\u002Fh3\u003E\u003Cp\u003E{{feature.description}}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"$ctrl.continueToRegister()\"\u003E Start your journey now\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("t+np");


/***/ }),

/***/ "0bPY":
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/**
 * @ngdoc module
 * @name ngTouch
 * @description
 *
 * The `ngTouch` module provides helpers for touch-enabled devices.
 * The implementation is based on jQuery Mobile touch event handling
 * ([jquerymobile.com](http://jquerymobile.com/)). *
 *
 * See {@link ngTouch.$swipe `$swipe`} for usage.
 *
 * @deprecated
 * sinceVersion="1.7.0"
 * The ngTouch module with the {@link ngTouch.$swipe `$swipe`} service and
 * the {@link ngTouch.ngSwipeLeft} and {@link ngTouch.ngSwipeRight} directives are
 * deprecated. Instead, stand-alone libraries for touch handling and gesture interaction
 * should be used, for example [HammerJS](https://hammerjs.github.io/) (which is also used by
 * Angular).
 */

// define ngTouch module
/* global ngTouch */
var ngTouch = angular.module('ngTouch', []);

ngTouch.info({ angularVersion: '1.8.3' });

function nodeName_(element) {
  return angular.$$lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

/* global ngTouch: false */

    /**
     * @ngdoc service
     * @name $swipe
     *
     * @deprecated
     * sinceVersion="1.7.0"
     *
     * See the {@link ngTouch module} documentation for more information.
     *
     * @description
     * The `$swipe` service is a service that abstracts the messier details of hold-and-drag swipe
     * behavior, to make implementing swipe-related directives more convenient.
     *
     * Requires the {@link ngTouch `ngTouch`} module to be installed.
     *
     * `$swipe` is used by the `ngSwipeLeft` and `ngSwipeRight` directives in `ngTouch`.
     *
     * # Usage
     * The `$swipe` service is an object with a single method: `bind`. `bind` takes an element
     * which is to be watched for swipes, and an object with four handler functions. See the
     * documentation for `bind` below.
     */

ngTouch.factory('$swipe', [function() {
  // The total distance in any direction before we make the call on swipe vs. scroll.
  var MOVE_BUFFER_RADIUS = 10;

  var POINTER_EVENTS = {
    'mouse': {
      start: 'mousedown',
      move: 'mousemove',
      end: 'mouseup'
    },
    'touch': {
      start: 'touchstart',
      move: 'touchmove',
      end: 'touchend',
      cancel: 'touchcancel'
    },
    'pointer': {
      start: 'pointerdown',
      move: 'pointermove',
      end: 'pointerup',
      cancel: 'pointercancel'
    }
  };

  function getCoordinates(event) {
    var originalEvent = event.originalEvent || event;
    var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
    var e = (originalEvent.changedTouches && originalEvent.changedTouches[0]) || touches[0];

    return {
      x: e.clientX,
      y: e.clientY
    };
  }

  function getEvents(pointerTypes, eventType) {
    var res = [];
    angular.forEach(pointerTypes, function(pointerType) {
      var eventName = POINTER_EVENTS[pointerType][eventType];
      if (eventName) {
        res.push(eventName);
      }
    });
    return res.join(' ');
  }

  return {
    /**
     * @ngdoc method
     * @name $swipe#bind
     *
     * @description
     * The main method of `$swipe`. It takes an element to be watched for swipe motions, and an
     * object containing event handlers.
     * The pointer types that should be used can be specified via the optional
     * third argument, which is an array of strings `'mouse'`, `'touch'` and `'pointer'`. By default,
     * `$swipe` will listen for `mouse`, `touch` and `pointer` events.
     *
     * The four events are `start`, `move`, `end`, and `cancel`. `start`, `move`, and `end`
     * receive as a parameter a coordinates object of the form `{ x: 150, y: 310 }` and the raw
     * `event`. `cancel` receives the raw `event` as its single parameter.
     *
     * `start` is called on either `mousedown`, `touchstart` or `pointerdown`. After this event, `$swipe` is
     * watching for `touchmove`, `mousemove` or `pointermove` events. These events are ignored until the total
     * distance moved in either dimension exceeds a small threshold.
     *
     * Once this threshold is exceeded, either the horizontal or vertical delta is greater.
     * - If the horizontal distance is greater, this is a swipe and `move` and `end` events follow.
     * - If the vertical distance is greater, this is a scroll, and we let the browser take over.
     *   A `cancel` event is sent.
     *
     * `move` is called on `mousemove`, `touchmove` and `pointermove` after the above logic has determined that
     * a swipe is in progress.
     *
     * `end` is called when a swipe is successfully completed with a `touchend`, `mouseup` or `pointerup`.
     *
     * `cancel` is called either on a `touchcancel` or `pointercancel`  from the browser, or when we begin scrolling
     * as described above.
     *
     */
    bind: function(element, eventHandlers, pointerTypes) {
      // Absolute total movement, used to control swipe vs. scroll.
      var totalX, totalY;
      // Coordinates of the start position.
      var startCoords;
      // Last event's position.
      var lastPos;
      // Whether a swipe is active.
      var active = false;

      pointerTypes = pointerTypes || ['mouse', 'touch', 'pointer'];
      element.on(getEvents(pointerTypes, 'start'), function(event) {
        startCoords = getCoordinates(event);
        active = true;
        totalX = 0;
        totalY = 0;
        lastPos = startCoords;
        if (eventHandlers['start']) {
          eventHandlers['start'](startCoords, event);
        }
      });
      var events = getEvents(pointerTypes, 'cancel');
      if (events) {
        element.on(events, function(event) {
          active = false;
          if (eventHandlers['cancel']) {
            eventHandlers['cancel'](event);
          }
        });
      }

      element.on(getEvents(pointerTypes, 'move'), function(event) {
        if (!active) return;

        // Android will send a touchcancel if it thinks we're starting to scroll.
        // So when the total distance (+ or - or both) exceeds 10px in either direction,
        // we either:
        // - On totalX > totalY, we send preventDefault() and treat this as a swipe.
        // - On totalY > totalX, we let the browser handle it as a scroll.

        if (!startCoords) return;
        var coords = getCoordinates(event);

        totalX += Math.abs(coords.x - lastPos.x);
        totalY += Math.abs(coords.y - lastPos.y);

        lastPos = coords;

        if (totalX < MOVE_BUFFER_RADIUS && totalY < MOVE_BUFFER_RADIUS) {
          return;
        }

        // One of totalX or totalY has exceeded the buffer, so decide on swipe vs. scroll.
        if (totalY > totalX) {
          // Allow native scrolling to take over.
          active = false;
          if (eventHandlers['cancel']) {
            eventHandlers['cancel'](event);
          }
          return;
        } else {
          // Prevent the browser from scrolling.
          event.preventDefault();
          if (eventHandlers['move']) {
            eventHandlers['move'](coords, event);
          }
        }
      });

      element.on(getEvents(pointerTypes, 'end'), function(event) {
        if (!active) return;
        active = false;
        if (eventHandlers['end']) {
          eventHandlers['end'](getCoordinates(event), event);
        }
      });
    }
  };
}]);

/* global ngTouch: false */

/**
 * @ngdoc directive
 * @name ngSwipeLeft
 *
 * @deprecated
 * sinceVersion="1.7.0"
 *
 * See the {@link ngTouch module} documentation for more information.
 *
 * @description
 * Specify custom behavior when an element is swiped to the left on a touchscreen device.
 * A leftward swipe is a quick, right-to-left slide of the finger.
 * Though ngSwipeLeft is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * To disable the mouse click and drag functionality, add `ng-swipe-disable-mouse` to
 * the `ng-swipe-left` or `ng-swipe-right` DOM Element.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeLeft {@link guide/expression Expression} to evaluate
 * upon left swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeLeftExample" deps="angular-touch.js" name="ng-swipe-left">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeLeftExample', ['ngTouch']);
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSwipeRight
 *
 * @deprecated
 * sinceVersion="1.7.0"
 *
 * See the {@link ngTouch module} documentation for more information.
 *
 * @description
 * Specify custom behavior when an element is swiped to the right on a touchscreen device.
 * A rightward swipe is a quick, left-to-right slide of the finger.
 * Though ngSwipeRight is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeRight {@link guide/expression Expression} to evaluate
 * upon right swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeRightExample" deps="angular-touch.js" name="ng-swipe-right">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeRightExample', ['ngTouch']);
      </file>
    </example>
 */

function makeSwipeDirective(directiveName, direction, eventName) {
  ngTouch.directive(directiveName, ['$parse', '$swipe', function($parse, $swipe) {
    // The maximum vertical delta for a swipe should be less than 75px.
    var MAX_VERTICAL_DISTANCE = 75;
    // Vertical distance should not be more than a fraction of the horizontal distance.
    var MAX_VERTICAL_RATIO = 0.3;
    // At least a 30px lateral motion is necessary for a swipe.
    var MIN_HORIZONTAL_DISTANCE = 30;

    return function(scope, element, attr) {
      var swipeHandler = $parse(attr[directiveName]);

      var startCoords, valid;

      function validSwipe(coords) {
        // Check that it's within the coordinates.
        // Absolute vertical distance must be within tolerances.
        // Horizontal distance, we take the current X - the starting X.
        // This is negative for leftward swipes and positive for rightward swipes.
        // After multiplying by the direction (-1 for left, +1 for right), legal swipes
        // (ie. same direction as the directive wants) will have a positive delta and
        // illegal ones a negative delta.
        // Therefore this delta must be positive, and larger than the minimum.
        if (!startCoords) return false;
        var deltaY = Math.abs(coords.y - startCoords.y);
        var deltaX = (coords.x - startCoords.x) * direction;
        return valid && // Short circuit for already-invalidated swipes.
            deltaY < MAX_VERTICAL_DISTANCE &&
            deltaX > 0 &&
            deltaX > MIN_HORIZONTAL_DISTANCE &&
            deltaY / deltaX < MAX_VERTICAL_RATIO;
      }

      var pointerTypes = ['touch'];
      if (!angular.isDefined(attr['ngSwipeDisableMouse'])) {
        pointerTypes.push('mouse');
      }
      $swipe.bind(element, {
        'start': function(coords, event) {
          startCoords = coords;
          valid = true;
        },
        'cancel': function(event) {
          valid = false;
        },
        'end': function(coords, event) {
          if (validSwipe(coords)) {
            scope.$apply(function() {
              element.triggerHandler(eventName);
              swipeHandler(scope, {$event: event});
            });
          }
        }
      }, pointerTypes);
    };
  }]);
}

// Left is negative X-coordinate, right is positive.
makeSwipeDirective('ngSwipeLeft', -1, 'swipeleft');
makeSwipeDirective('ngSwipeRight', 1, 'swiperight');



})(window, window.angular);


/***/ }),

/***/ "1i11":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"quiz-step struggles-step\"\u003E\u003Ch2\u003EWhat are you struggling with?\u003C\u002Fh2\u003E\u003Cp class=\"subtitle\"\u003ESelect all that apply\u003C\u002Fp\u003E\u003Cdiv class=\"options\"\u003E\u003Cdiv class=\"option\" ng-repeat=\"option in $ctrl.options\" ng-click=\"$ctrl.toggleOption(option)\" ng-class=\"{selected: $ctrl.selectedOptions.indexOf(option) !== -1}\"\u003E\u003Cdiv class=\"option-text\"\u003E{{option.text}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"$ctrl.nextStep()\" ng-disabled=\"!$ctrl.selectedOptions.length\"\u003E NEXT\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "3Pag":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer","footer-content":"footer-content","footer-logo-container":"footer-logo-container","footer-logo":"footer-logo","legal-container":"legal-container","navigation-item-container":"navigation-item-container","navigation-item":"navigation-item","social-container":"social-container","icon":"icon","contact-container":"contact-container","email-container":"email-container"};

/***/ }),

/***/ "5nj5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__word_switcher_cmpt__ = __webpack_require__("F7AD");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('presentation.component.word-switcher', []).component(__WEBPACK_IMPORTED_MODULE_1__word_switcher_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__word_switcher_cmpt__["a" /* default */]));

/***/ }),

/***/ "7M3B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"hidden":"hidden","page-wrapper":"page-wrapper","conversion-quiz":"conversion-quiz","progress-container":"progress-container","progress-bar":"progress-bar","step-indicator":"step-indicator","step":"step","step-dot":"step-dot","step-label":"step-label","active":"active","completed":"completed","step-content":"step-content","fadeIn":"fadeIn","ng-enter":"ng-enter","ng-leave":"ng-leave","ng-enter-active":"ng-enter-active","ng-leave-active":"ng-leave-active","quiz-step":"quiz-step","options":"options","option":"option","selected":"selected","btn":"btn","btn-primary":"btn-primary"};

/***/ }),

/***/ "BY2x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conversion_quiz_style_sass__ = __webpack_require__("7M3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conversion_quiz_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__conversion_quiz_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conversion_quiz_tpl_pug__ = __webpack_require__("Q75c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conversion_quiz_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__conversion_quiz_tpl_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_analytics__ = __webpack_require__("3pWh");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var ConversionQuizController = function () {
    ConversionQuizController.$inject = ['$state', '$transitions', '$window'];

    /* @ngInject */
    function ConversionQuizController($state, $transitions, $window) {
        _classCallCheck(this, ConversionQuizController);

        this.$state = $state;
        this.$transitions = $transitions;
        this.$window = $window;

        // Define all steps for progress tracking
        this.steps = [{ name: 'welcome', title: 'Welcome' }, { name: 'struggles', title: 'Your Challenges' }, { name: 'tracking', title: 'Current Method' }, { name: 'goal', title: 'Your Goals' }, { name: 'suggestion', title: 'Solution' },
        // Temporarily disabled plans step
        // { name: 'plans', title: 'Choose Plan' },
        { name: 'register', title: 'Sign Up' }, { name: 'download', title: 'Get Started' }];

        // Store answers as user progresses
        this.answers = {};
    }

    _createClass(ConversionQuizController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // If no state is selected, go to welcome
            if (this.$state.current.name === 'conversion-quiz') {
                this.$state.go('conversion-quiz.welcome');
            }

            // Track current step for progress indicator
            this.$transitions.onSuccess({}, function (transition) {
                var toState = transition.to();
                _this.currentStep = _this.steps.findIndex(function (step) {
                    return toState.name === 'conversion-quiz.' + step.name;
                });

                // Track page view
                var currentStep = _this.steps[_this.currentStep];
                if (currentStep) {
                    __WEBPACK_IMPORTED_MODULE_2_common_analytics__["c" /* default */].trackPageView('/start/' + currentStep.name);
                }
            });

            // Scroll to top before transition starts
            this.$transitions.onBefore({}, function () {
                _this.$window.scrollTo(0, 0);
            });
        }

        // Navigate to next step

    }, {
        key: 'nextStep',
        value: function nextStep() {
            var nextIndex = this.currentStep + 1;
            if (nextIndex < this.steps.length) {
                this.$state.go('conversion-quiz.' + this.steps[nextIndex].name);
            }
        }

        // Store answer and move to next step

    }, {
        key: 'submitAnswer',
        value: function submitAnswer(questionKey, answer) {
            this.answers[questionKey] = answer;

            // Track answer
            __WEBPACK_IMPORTED_MODULE_2_common_analytics__["c" /* default */].trackEvent('Conversion Quiz', 'answer', questionKey, null, {
                answerValue: (typeof answer === 'undefined' ? 'undefined' : _typeof(answer)) === 'object' ? JSON.stringify(answer) : answer
            });
            this.nextStep();
        }

        // Get current progress percentage

    }, {
        key: 'getProgress',
        value: function getProgress() {
            return (this.currentStep + 1) / this.steps.length * 100;
        }
    }]);

    return ConversionQuizController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    template: __WEBPACK_IMPORTED_MODULE_1__conversion_quiz_tpl_pug___default()(),
    controller: ConversionQuizController
});

/***/ }),

/***/ "Es1N":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-app-store-download-5ce9749a693f6434.png";

/***/ }),

/***/ "F7AD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce__ = __webpack_require__("M+Z9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__word_switcher_style_sass__ = __webpack_require__("TzRF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__word_switcher_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__word_switcher_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__word_switcher_tpl_pug__ = __webpack_require__("bNkJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__word_switcher_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__word_switcher_tpl_pug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var WordSwitcherController = function () {
    WordSwitcherController.$inject = ['$interval'];

    /* @ngInject */
    function WordSwitcherController($interval) {
        _classCallCheck(this, WordSwitcherController);

        this.$interval = $interval;
    }

    _createClass(WordSwitcherController, [{
        key: '$onInit',
        value: function $onInit() {
            this.index = 0;

            this.id = this.$interval(this.selectNext.bind(this), this.interval);
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.$interval.cancel(this.id);
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.words) {
                this.word = __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default()(this.words || [], function (longest, word) {
                    return !longest || longest.length < word.length ? word : longest;
                }, null);
            }
        }
    }, {
        key: 'selectNext',
        value: function selectNext() {
            this.leave = this.index;
            this.index = (this.index + 1) % this.words.length;
            this.enter = this.index;
        }
    }]);

    return WordSwitcherController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbPWordSwitcher',
    template: __WEBPACK_IMPORTED_MODULE_2__word_switcher_tpl_pug___default()(),
    controller: WordSwitcherController,
    bindings: {
        words: '<',
        interval: '<'
    }
});

/***/ }),

/***/ "G7rK":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"quiz-step download-step\"\u003E\u003Ch2\u003EChoose Your Platform\u003C\u002Fh2\u003E\u003Cp class=\"subtitle\"\u003EYour account is ready! Choose how you want to access Dollarbird\u003C\u002Fp\u003E\u003Cdiv class=\"platforms\"\u003E\u003Cdiv class=\"platform\" ng-repeat=\"platform in $ctrl.platforms\" ng-click=\"$ctrl.downloadApp(platform)\"\u003E\u003Cdiv class=\"platform-icon\"\u003E\u003Ci class=\"icon icon-dollarbird-{{platform.icon}}\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003E{{platform.name}}\u003C\u002Fh3\u003E\u003Cp\u003E{{platform.description}}\u003C\u002Fp\u003E\u003Cbutton class=\"button button-primary\" type=\"button\"\u003EGet Started\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"help-text\"\u003E\u003Cp\u003ENeed help getting started? \u003Ca href=\"https:\u002F\u002Fhelp.dev.dollarbird.co\" target=\"_blank\"\u003ECheck our Help Center\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "HCns":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-download-screenshot-5532c707ecd2d5ef.png";

/***/ }),

/***/ "HDkY":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"quiz-step goal-step\"\u003E\u003Ch2\u003EWhat's Your Main Financial Goal?\u003C\u002Fh2\u003E\u003Cp class=\"subtitle\"\u003ESelect all the financial goals you want to achieve\u003C\u002Fp\u003E\u003Cdiv class=\"options\"\u003E\u003Cdiv class=\"option\" ng-repeat=\"goal in $ctrl.goals\" ng-class=\"{ selected: $ctrl.isSelected(goal) }\" ng-click=\"$ctrl.selectGoal(goal)\"\u003E\u003Cdiv class=\"option-text\"\u003E\u003Ch3\u003E{{goal.title}}\u003C\u002Fh3\u003E\u003Cp\u003E{{goal.description}}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"$ctrl.nextStep()\" ng-disabled=\"!$ctrl.selectedGoals.length\"\u003E NEXT\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "I2sI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"testimonial":"testimonial","testimonial-content":"testimonial-content","testimonial-placeholder":"testimonial-placeholder","testimonial-slides":"testimonial-slides","testimonial-slide-item":"testimonial-slide-item","active":"active","testimonial-slide":"testimonial-slide","left-in":"left-in","slide-in-left":"slide-in-left","left-out":"left-out","slide-out-left":"slide-out-left","right-in":"right-in","slide-in-right":"slide-in-right","right-out":"right-out","slide-out-right":"slide-out-right","testimonial-slide-content":"testimonial-slide-content","testimonial-slide-author":"testimonial-slide-author","testimonial-dots":"testimonial-dots","button-select-testimonial":"button-select-testimonial"};

/***/ }),

/***/ "IMCk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__footer_style_sass__ = __webpack_require__("3Pag");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__footer_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__footer_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer_tpl_pug__ = __webpack_require__("xvAI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__footer_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var FooterController = function () {
    FooterController.$inject = ['configuration'];

    /* @ngInject */
    function FooterController(configuration) {
        _classCallCheck(this, FooterController);

        this.configuration = configuration;
    }

    _createClass(FooterController, [{
        key: '$onInit',
        value: function $onInit() {
            this.salesEmail = this.configuration.salesEmail;
            this.facebookUrl = this.configuration.socialFacebookUrl;
            this.twitterUrl = this.configuration.socialTwitterUrl;
            this.helpCenterUrl = this.configuration.helpCenterUrl;
            this.pressKitUrl = this.configuration.pressKitUrl;
        }
    }]);

    return FooterController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbPFooter',
    template: __WEBPACK_IMPORTED_MODULE_1__footer_tpl_pug___default()(),
    controller: FooterController
});

/***/ }),

/***/ "LBM7":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"testimonial\"\u003E\u003Cdiv class=\"testimonial-content\"\u003E\u003Cdiv class=\"testimonial-placeholder\"\u003E\u003Cdiv class=\"testimonial-slide-content\" ng-bind=\"$ctrl.testimonial.content\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"testimonial-slide-author\" ng-bind=\"$ctrl.testimonial.author\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"testimonial-slides\"\u003E\u003Cdiv class=\"testimonial-slide-item\" ng-repeat=\"testimonial in $ctrl.testimonials track by $index\" ng-class=\"{ active: $ctrl.current == $index, 'left-in': $ctrl.leftIn === $index, 'left-out': $ctrl.leftOut === $index, 'right-in': $ctrl.rightIn === $index, 'right-out': $ctrl.rightOut === $index }\" ng-swipe-left=\"$ctrl.selectNext()\" ng-swipe-right=\"$ctrl.selectPrevious()\"\u003E\u003Cdiv class=\"testimonial-slide\"\u003E\u003Cdiv class=\"testimonial-slide-content\" ng-bind=\"testimonial.content\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"testimonial-slide-author\" ng-bind=\"testimonial.author\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"testimonial-dots\"\u003E\u003Cbutton class=\"button button-select-testimonial\" ng-repeat=\"testimonial in $ctrl.testimonials track by $index\" ng-click=\"$ctrl.select($index)\" ng-class=\"{ active: $ctrl.current == $index }\"\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "M3T8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-collaborator-screenshot-4f7167747b356077.png";

/***/ }),

/***/ "NLQ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_provider_subscribable_provider__ = __webpack_require__("OymO");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SessionService = function (_Subscribable) {
    SessionService.$inject = ['$q', 'apiService', 'storageService', 'appStartCacheService', 'diagnosticsService'];

    _inherits(SessionService, _Subscribable);

    /* @ngInject */
    function SessionService($q, apiService, storageService, appStartCacheService, diagnosticsService) {
        _classCallCheck(this, SessionService);

        var _this = _possibleConstructorReturn(this, (SessionService.__proto__ || Object.getPrototypeOf(SessionService)).call(this));

        _this.$q = $q;
        _this.apiService = apiService;
        _this.storageService = storageService;
        _this.appStartCacheService = appStartCacheService;
        _this.diagnosticsService = diagnosticsService;

        _this.promise = null;
        return _this;
    }

    _createClass(SessionService, [{
        key: 'reload',
        value: function reload() {
            var _this2 = this;

            return this.initialize(true).catch(function (error) {
                return _this2.$q.reject(error);
            });
        }
    }, {
        key: 'initialize',
        value: function initialize(reload) {
            var _this3 = this;

            if (!reload && this.promise) {
                return this.promise;
            }

            this.promise = this.apiService.onlyAuthorized().then(function () {
                return _this3.apiService.get('/context').then(function (result) {
                    return _this3.updateUser(result);
                }).catch(function (error) {
                    _this3.clearUser();
                    return _this3.$q.reject(error);
                });
            }).catch(function (error) {
                _this3.clearUser();
                return _this3.$q.reject(error);
            });

            return this.promise;
        }
    }, {
        key: 'updateUser',
        value: function updateUser(result) {
            if (result.data && result.data.user) {
                this.user = result.data.user;
                return result.data;
            }

            this.clearUser();
            return this.$q.reject('We were unable to read and process your initial request. Please try again later.');
        }
    }, {
        key: 'deleteAccount',
        value: function deleteAccount() {
            var _this4 = this;

            return this.apiService.delete('/users/me').finally(function () {
                _this4.changeTokenAndReload();
            });
        }
    }, {
        key: 'clearUser',
        value: function clearUser() {
            this.user = null;
        }
    }, {
        key: 'signIn',
        value: function signIn(identity, password) {
            var _this5 = this;

            this.diagnosticsService.info('sign_in_attempt', {
                identityProvided: !!identity
            });

            return this.apiService.post('/sign-in', {
                identity: identity,
                password: password
            }, {
                anonymous: true
            }).then(function (result) {
                return _this5.changeTokenAndReload(result).then(function (data) {
                    if (!data || !data.user) {
                        _this5.diagnosticsService.error('sign_in_missing_user_after_reload');
                        return _this5.$q.reject(new Error('No user data after reload'));
                    }
                    _this5.diagnosticsService.info('sign_in_success', {
                        userId: data.user && data.user.id
                    });
                    return _this5.fire('sign-in', data.user);
                });
            }).catch(function (error) {
                _this5.diagnosticsService.warn('sign_in_failed', _this5.diagnosticsService.describeHttpError(error));
                return _this5.$q.reject(error || new Error('Sign in failed'));
            });
        }
    }, {
        key: 'signUp',
        value: function signUp(name, identity, password) {
            var _this6 = this;

            return this.apiService.post('/sign-up', {
                name: name,
                identity: identity,
                password: password,
                email: identity
            }, {
                anonymous: true
            }).then(function () {
                return _this6.signIn(identity, password);
            }).catch(function (error) {
                return _this6.$q.reject(error);
            });
        }
    }, {
        key: 'signOut',
        value: function signOut() {
            var _this7 = this;

            this.diagnosticsService.info('sign_out_requested');
            return this.apiService.post('/sign-out').then(function (result) {
                _this7.finalizeSignOut();
                _this7.diagnosticsService.info('sign_out_completed');
                return result;
            }).catch(function (error) {
                _this7.diagnosticsService.warn('sign_out_failed', _this7.diagnosticsService.describeHttpError(error));
                return _this7.$q.reject(error);
            });
        }
    }, {
        key: 'finalizeSignOut',
        value: function finalizeSignOut() {
            // Clear the token and user data after a successful sign-out.
            this.appStartCacheService.clearAll();
            this.apiService.token = null;
            this.promise = null;
            this.storageService.setUserPrefix(null);
            this.clearUser();
            this.fire('change', null);
        }
    }, {
        key: 'refreshToken',
        value: function refreshToken() {
            var _this8 = this;

            this.diagnosticsService.info('refresh_token_attempt');
            return this.apiService.post('/refresh-token', null, {
                anonymous: true
            }).then(function (result) {
                _this8.diagnosticsService.info('refresh_token_success');
                return _this8.changeToken(result);
            }).catch(function (error) {
                _this8.diagnosticsService.warn('refresh_token_failed', _this8.diagnosticsService.describeHttpError(error));
                return _this8.$q.reject(error);
            });
        }
    }, {
        key: 'changeToken',
        value: function changeToken(result) {
            var token = result && result.data && result.data.token ? result.data.token : null;

            if (!token) {
                this.diagnosticsService.error('change_token_missing_token');
                return this.$q.reject(new Error('No token received'));
            }

            this.apiService.token = token;
            this.fire('change', token);

            return this.$q.resolve(token);
        }
    }, {
        key: 'changeTokenAndReload',
        value: function changeTokenAndReload(result) {
            var _this9 = this;

            return this.changeToken(result).then(function () {
                return _this9.apiService.onlyAuthorized().then(function () {
                    return _this9.reload();
                });
            }).catch(function (error) {
                return _this9.reload().then(function () {
                    return _this9.$q.reject(error);
                });
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(callback) {
            return this.on('change', callback);
        }
    }, {
        key: 'onSignIn',
        value: function onSignIn(callback) {
            return this.on('sign-in', callback);
        }
    }]);

    return SessionService;
}(Object(__WEBPACK_IMPORTED_MODULE_0_common_provider_subscribable_provider__["a" /* default */])());

/* harmony default export */ __webpack_exports__["a"] = (SessionService);

/***/ }),

/***/ "NY7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentService = function () {
    PaymentService.$inject = ['$q', 'apiService'];

    /* @ngInject */
    function PaymentService($q, apiService) {
        _classCallCheck(this, PaymentService);

        this.$q = $q;
        this.apiService = apiService;
    }

    _createClass(PaymentService, [{
        key: 'getBuyUrl',
        value: function getBuyUrl(subscriptionId) {
            var _this = this;

            return this.apiService.post('/subscriptions/avangate/buy-link', null, {
                params: {
                    subscriptionId: subscriptionId
                }
            }).then(function (result) {
                if (result.data && result.data.link) {
                    return result.data.link;
                }
                return _this.$q.reject(new Error('No payment link received'));
            }).catch(function (error) {
                return _this.$q.reject(error);
            });
        }
    }, {
        key: 'confirm',
        value: function confirm(avangateCtrl, token) {
            return this.apiService.post('/subscriptions/avangate/payments', {
                avangateCtrl: avangateCtrl,
                token: token
            });
        }
    }]);

    return PaymentService;
}();

/* harmony default export */ __webpack_exports__["a"] = (PaymentService);

/***/ }),

/***/ "OCPK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"plans-step":"plans-step","loading-state":"loading-state","spinner":"spinner","spin":"spin","subtitle":"subtitle","plan-types":"plan-types","plan-type":"plan-type","type-title":"type-title","options":"options","option":"option","recommended":"recommended","badge":"badge","option-text":"option-text","price":"price","amount":"amount","period":"period","savings":"savings","features":"features","selected":"selected","btn-primary":"btn-primary"};

/***/ }),

/***/ "Op+b":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cheader class=\"header\" ng-class=\"{ 'quiz-header': $ctrl.$state.includes('conversion-quiz') }\"\u003E\u003Ca class=\"header-logo\" ui-sref=\"landing\" target=\"_self\"\u003E\u003Cdb-logo\u003E\u003C\u002Fdb-logo\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"navigation-container\"\u003E\u003Cbutton class=\"button button-icon button-toggle-navigation\" ng-click=\"$ctrl.toggleNavigation()\"\u003E\u003Ci class=\"icon icon-dollarbird-close\" ng-show=\"$ctrl.navigationVisible\"\u003E\u003C\u002Fi\u003E\u003Ci class=\"icon icon-dollarbird-menu\" ng-hide=\"$ctrl.navigationVisible\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cnav class=\"navigation\" ng-class=\"{ visible: $ctrl.navigationVisible }\"\u003E\u003Cdiv class=\"navigation-items\"\u003E\u003Cdiv class=\"navigation-item\"\u003E\u003Cbutton class=\"navigation-link\" type=\"button\" scroll-to=\"pricing\" ng-click=\"$ctrl.closeNavigation()\"\u003EPlans\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navigation-item\"\u003E\u003Ca class=\"navigation-link\" ui-sref=\"sign-in\" ui-sref-active=\"active\" ng-click=\"$ctrl.closeNavigation()\"\u003ELogin\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navigation-item\"\u003E\u003Ca class=\"navigation-link navigation-link-sign-up\" ui-sref=\"sign-up\" ui-sref-active=\"active\" ng-click=\"$ctrl.closeNavigation()\"\u003ESign up\u003C\u002Fa\u003E\u003Ca class=\"button button-outline button-secondary navigation-button-sign-up\" ui-sref=\"sign-up\" ui-sref-active=\"active\" ng-click=\"$ctrl.closeNavigation()\"\u003ESign up\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "P+yq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"download-step":"download-step","platforms":"platforms","platform":"platform","platform-icon":"platform-icon","help-text":"help-text"};

/***/ }),

/***/ "PeML":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-hero-screenshot-e7146bb93aeb0568.png";

/***/ }),

/***/ "Q75c":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"conversion-quiz\"\u003E\u003Cdiv class=\"progress-container\"\u003E\u003Cdiv class=\"progress-bar\" style=\"width: {{$ctrl.getProgress()}}%\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"step-indicator hidden\"\u003E\u003Cdiv class=\"step\" ng-repeat=\"step in $ctrl.steps\" ng-class=\"{active: $ctrl.currentStep === $index, completed: $ctrl.currentStep &gt; $index}\"\u003E\u003Cdiv class=\"step-dot\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"step-label\"\u003E{{step.title}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"step-content\"\u003E\u003Cdiv ui-view=\"\" answers=\"$ctrl.answers\" on-submit=\"$ctrl.submitAnswer(questionKey, answer)\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "QD74":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"register-step":"register-step","subtitle":"subtitle","error-message":"error-message","general":"general","form-group":"form-group","error":"error","form-actions":"form-actions"};

/***/ }),

/***/ "QJQ8":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("0bPY");
module.exports = 'ngTouch';


/***/ }),

/***/ "TzRF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"word-switcher":"word-switcher","placeholder":"placeholder","word":"word","enter":"enter","visible":"visible","leave":"leave"};

/***/ }),

/***/ "VgOx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__landing_cmpt__ = __webpack_require__("hPqF");
stateConfiguration.$inject = ['$stateProvider'];




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('presentation.scene.landing', []).component(__WEBPACK_IMPORTED_MODULE_1__landing_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_1__landing_cmpt__["a" /* default */]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('landing', {
        url: '/',
        template: '<db-p-landing></db-p-landing>'
    });
}

/***/ }),

/***/ "Wuyx":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"quiz-step tracking-step\"\u003E\u003Ch2\u003EHow do you currently track your finances?\u003C\u002Fh2\u003E\u003Cp class=\"subtitle\"\u003EChoose the option that best describes your current method\u003C\u002Fp\u003E\u003Cdiv class=\"options\"\u003E\u003Cdiv class=\"option\" ng-repeat=\"option in $ctrl.options\" ng-click=\"$ctrl.selectOption(option)\" ng-class=\"{ selected: $ctrl.selectedOption === option }\"\u003E\u003Cdiv class=\"option-text\"\u003E\u003Ch3\u003E{{option.title}}\u003C\u002Fh3\u003E\u003Cp\u003E{{option.description}}\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"$ctrl.nextStep()\" ng-disabled=\"!$ctrl.selectedOption\"\u003E NEXT\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "X2Q6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-calendar-screenshot-b4c13ca0771ee427.png";

/***/ }),

/***/ "XJd6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__welcome_style_sass__ = __webpack_require__("w9zy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__welcome_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__welcome_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__welcome_tpl_pug__ = __webpack_require__("xuSX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__welcome_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__welcome_tpl_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_component_logo__ = __webpack_require__("EOYN");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var WelcomeController = function () {
    WelcomeController.$inject = ['$state'];

    /* @ngInject */
    function WelcomeController($state) {
        _classCallCheck(this, WelcomeController);

        this.$state = $state;
    }

    _createClass(WelcomeController, [{
        key: 'startQuiz',
        value: function startQuiz() {
            this.onSubmit({ questionKey: 'started', answer: true });
            this.$state.go('conversion-quiz.struggles');
        }
    }]);

    return WelcomeController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    bindings: {
        onSubmit: '&'
    },
    template: __WEBPACK_IMPORTED_MODULE_1__welcome_tpl_pug___default()(),
    controller: WelcomeController
});

/***/ }),

/***/ "XW0t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plans_style_sass__ = __webpack_require__("OCPK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plans_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__plans_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plans_tpl_pug__ = __webpack_require__("pwjX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plans_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__plans_tpl_pug__);
PlansController.$inject = ['$state', 'apiService'];



/* @ngInject */
function PlansController($state, apiService) {
    this.$state = $state;
    this.apiService = apiService;
    this.loading = true;
    this.plans = [];

    this.$onInit = function () {
        var self = this;
        // Fetch available plans from API
        this.apiService.get('/subscriptions/plans', {
            params: {
                upgradeOnly: false,
                withPrice: true
            }
        }).then(function (response) {
            self.plans = self._transformPlans(response.data);
            self.loading = false;
        }).catch(function () {
            // Fallback to default plans if API fails
            this.plans = [{
                id: 'pro-monthly',
                type: 'Pro',
                name: 'Monthly',
                price: '$5',
                period: 'per month',
                features: ['Smart Calendar View', 'AI-Powered Insights', 'Bank Account Sync', 'Smart Budgeting', 'Unlimited Categories']
            }, {
                id: 'pro-annual',
                type: 'Pro',
                name: 'Annual',
                price: '$48',
                period: 'per year',
                savings: 'Save 20%',
                features: ['Smart Calendar View', 'AI-Powered Insights', 'Bank Account Sync', 'Smart Budgeting', 'Unlimited Categories']
            }, {
                id: 'unlimited-monthly',
                type: 'Pro Unlimited',
                name: 'Monthly',
                price: '$10',
                period: 'per month',
                features: ['All Pro Features', 'Priority Support', 'Advanced Analytics', 'Export to Excel', 'Family Sharing']
            }, {
                id: 'unlimited-annual',
                type: 'Pro Unlimited',
                name: 'Annual',
                price: '$96',
                period: 'per year',
                savings: 'Save 20%',
                features: ['All Pro Features', 'Priority Support', 'Advanced Analytics', 'Export to Excel', 'Family Sharing'],
                recommended: true
            }];
        });
    };
}

PlansController.prototype._transformPlans = function (apiPlans) {
    return apiPlans.filter(function (plan) {
        return plan.subscriptions && plan.subscriptions.length > 0;
    }).reduce(function (acc, plan) {
        var planSubs = plan.subscriptions.map(function (sub) {
            return {
                id: sub.id.toString(),
                type: plan.name,
                name: sub.title,
                price: sub.currency + sub.price,
                period: sub.frequency === 1 ? 'per month' : 'per year',
                features: plan.features,
                savings: sub.frequency === 12 ? 'Save 20%' : null,
                recommended: plan.name === 'Pro Unlimited' && sub.frequency === 12,
                // Ensure color is lowercase and has fallback
                color: plan.color ? plan.color.toLowerCase() : '#00a3ff'
            };
        });
        return acc.concat(planSubs);
    }, []);
};

PlansController.prototype.selectPlan = function (plan) {
    this.selectedPlan = plan;
};

PlansController.prototype.nextStep = function () {
    if (this.selectedPlan) {
        this.onSubmit({ questionKey: 'selected_plan', answer: this.selectedPlan.id });
        this.$state.go('conversion-quiz.register');
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    template: __WEBPACK_IMPORTED_MODULE_1__plans_tpl_pug___default()(),
    controller: PlansController,
    bindings: {
        onSubmit: '&'
    }
});

/***/ }),

/***/ "YYwa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_touch__ = __webpack_require__("QJQ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__testimonial_cmpt__ = __webpack_require__("xhR+");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('presentation.component.testimonial', [__WEBPACK_IMPORTED_MODULE_1_angular_touch___default.a]).component(__WEBPACK_IMPORTED_MODULE_2__testimonial_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__testimonial_cmpt__["a" /* default */]));

/***/ }),

/***/ "av5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__download_style_sass__ = __webpack_require__("P+yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__download_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__download_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__download_tpl_pug__ = __webpack_require__("G7rK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__download_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__download_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var DownloadController = function () {
    DownloadController.$inject = ['$window'];

    /* @ngInject */
    function DownloadController($window) {
        _classCallCheck(this, DownloadController);

        this.$window = $window;
        this.platforms = [{
            id: 'web',
            name: 'Web App',
            description: 'Use Dollarbird in your browser',
            icon: 'desktop',
            url: 'http://app.localhost:3000'
        }, {
            id: 'ios',
            name: 'iOS App',
            description: 'Download from the App Store',
            icon: 'apple',
            url: 'https://get.dev.dollarbird.co/ios'
        }, {
            id: 'android',
            name: 'Android App',
            description: 'Get it on Google Play',
            icon: 'android',
            url: 'https://get.dev.dollarbird.co/android'
        }];
    }

    _createClass(DownloadController, [{
        key: 'downloadApp',
        value: function downloadApp(platform) {
            this.onSubmit({
                questionKey: 'download_platform',
                answer: platform.id
            });
            this.$window.location.href = platform.url;
        }
    }]);

    return DownloadController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    template: __WEBPACK_IMPORTED_MODULE_1__download_tpl_pug___default()(),
    controller: DownloadController,
    bindings: {
        onSubmit: '&'
    }
});

/***/ }),

/***/ "bNkJ":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"word-switcher\"\u003E\u003Cspan class=\"placeholder\" ng-bind=\"$ctrl.word\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"word\" ng-repeat=\"word in $ctrl.words track by $index\" ng-class=\"{ visible: $ctrl.index === $index, leave: $ctrl.leave === $index, enter: $ctrl.enter === $index }\" ng-bind=\"word\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "c00M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"struggles-step":"struggles-step","subtitle":"subtitle","options":"options","option":"option","selected":"selected","btn-primary":"btn-primary"};

/***/ }),

/***/ "cW+L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uirouter_angularjs__ = __webpack_require__("7Cuf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common__ = __webpack_require__("1lyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conversion_quiz_cmpt__ = __webpack_require__("BY2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__steps_welcome_welcome_cmpt__ = __webpack_require__("XJd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__steps_struggles_struggles_cmpt__ = __webpack_require__("xOGg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__steps_tracking_tracking_cmpt__ = __webpack_require__("gpPU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__steps_goal_goal_cmpt__ = __webpack_require__("sQr7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__steps_suggestion_suggestion_cmpt__ = __webpack_require__("q3yg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__steps_plans_plans_cmpt__ = __webpack_require__("XW0t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__steps_register_register_cmpt__ = __webpack_require__("nJlj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__steps_download_download_cmpt__ = __webpack_require__("av5s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_application_service_session_service__ = __webpack_require__("NLQ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_application_service_payment_payment_service__ = __webpack_require__("NY7f");
routerConfiguration.$inject = ['$stateProvider', '$urlRouterProvider'];














// Import required services



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('presentation.scene.conversion-quiz', [__WEBPACK_IMPORTED_MODULE_1__uirouter_angularjs__["default"], __WEBPACK_IMPORTED_MODULE_2_common__["f" /* default */].name]).service('sessionService', __WEBPACK_IMPORTED_MODULE_12_application_service_session_service__["a" /* default */]).service('paymentService', __WEBPACK_IMPORTED_MODULE_13_application_service_payment_payment_service__["a" /* default */]).run(['apiService', function (apiService) {
    // Temporarily set API URL for testing
    apiService.api = 'https://api.dollarbird.co/v1';
}]).component('dbConversionQuiz', __WEBPACK_IMPORTED_MODULE_3__conversion_quiz_cmpt__["a" /* default */]).component('dbQuizWelcome', __WEBPACK_IMPORTED_MODULE_4__steps_welcome_welcome_cmpt__["a" /* default */]).component('dbQuizStruggles', __WEBPACK_IMPORTED_MODULE_5__steps_struggles_struggles_cmpt__["a" /* default */]).component('dbQuizTracking', __WEBPACK_IMPORTED_MODULE_6__steps_tracking_tracking_cmpt__["a" /* default */]).component('dbQuizGoal', __WEBPACK_IMPORTED_MODULE_7__steps_goal_goal_cmpt__["a" /* default */]).component('dbQuizSuggestion', __WEBPACK_IMPORTED_MODULE_8__steps_suggestion_suggestion_cmpt__["a" /* default */]).component('dbQuizPlans', __WEBPACK_IMPORTED_MODULE_9__steps_plans_plans_cmpt__["a" /* default */]).component('dbQuizRegister', __WEBPACK_IMPORTED_MODULE_10__steps_register_register_cmpt__["a" /* default */]).component('dbQuizDownload', __WEBPACK_IMPORTED_MODULE_11__steps_download_download_cmpt__["a" /* default */]).config(routerConfiguration));

/* @ngInject */
function routerConfiguration($stateProvider, $urlRouterProvider) {
    // Redirect /start to /start/welcome
    $urlRouterProvider.when('/start', '/start/welcome');

    $stateProvider.state('conversion-quiz', {
        url: '/start',
        component: 'dbConversionQuiz',
        data: {
            title: 'Find Your Perfect Financial Tool'
        }
    }).state('conversion-quiz.welcome', {
        url: '/welcome',
        component: 'dbQuizWelcome'
    }).state('conversion-quiz.struggles', {
        url: '/struggles',
        component: 'dbQuizStruggles'
    }).state('conversion-quiz.tracking', {
        url: '/current-tracking',
        component: 'dbQuizTracking'
    }).state('conversion-quiz.goal', {
        url: '/goal',
        component: 'dbQuizGoal'
    }).state('conversion-quiz.suggestion', {
        url: '/suggestion',
        component: 'dbQuizSuggestion'
    })
    // Temporarily disabled plans step
    // .state('conversion-quiz.plans', {
    //     url: '/plans',
    //     component: 'dbQuizPlans'
    // })
    .state('conversion-quiz.register', {
        url: '/register',
        component: 'dbQuizRegister'
    }).state('conversion-quiz.download', {
        url: '/download',
        component: 'dbQuizDownload'
    });
}

/***/ }),

/***/ "dvC6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"link","disabled":"disabled","button":"button","button-block":"button-block","button-icon":"button-icon","icon":"icon","button-link":"button-link","button-danger":"button-danger","button-remove":"button-remove","button-add":"button-add","icon-dollarbird-plus":"icon-dollarbird-plus","button-fill":"button-fill","button-primary":"button-primary","button-secondary":"button-secondary","button-outline":"button-outline","readonly":"readonly","block-component":"block-component","icon-dollarbird-grip":"icon-dollarbird-grip","icon-dollarbird-multiple":"icon-dollarbird-multiple","icon-dollarbird-search":"icon-dollarbird-search","icon-dollarbird-delete":"icon-dollarbird-delete","icon-dollarbird-edit":"icon-dollarbird-edit","icon-dollarbird-users":"icon-dollarbird-users","icon-dollarbird-balance-update":"icon-dollarbird-balance-update","icon-dollarbird-transfer":"icon-dollarbird-transfer","icon-dollarbird-close":"icon-dollarbird-close","icon-dollarbird-settings":"icon-dollarbird-settings","icon-dollarbird-readonly":"icon-dollarbird-readonly","icon-dollarbird-premium":"icon-dollarbird-premium","icon-dollarbird-twitter":"icon-dollarbird-twitter","icon-dollarbird-facebook":"icon-dollarbird-facebook","icon-dollarbird-dashboard":"icon-dollarbird-dashboard","icon-dollarbird-menu":"icon-dollarbird-menu","icon-dollarbird-minus":"icon-dollarbird-minus","icon-dollarbird-name":"icon-dollarbird-name","icon-dollarbird-email":"icon-dollarbird-email","icon-dollarbird-password":"icon-dollarbird-password","icon-dollarbird-chevron-left":"icon-dollarbird-chevron-left","icon-dollarbird-chevron-right":"icon-dollarbird-chevron-right","icon-dollarbird-chevron-up":"icon-dollarbird-chevron-up","icon-dollarbird-chevron-down":"icon-dollarbird-chevron-down","icon-dollarbird-repeat":"icon-dollarbird-repeat","icon-dollarbird-arrow-left":"icon-dollarbird-arrow-left","icon-dollarbird-arrow-right":"icon-dollarbird-arrow-right","icon-dollarbird-checkmark":"icon-dollarbird-checkmark","icon-dollarbird-calendar":"icon-dollarbird-calendar","icon-dollarbird-details":"icon-dollarbird-details","presentation-application":"presentation-application","presentation-content":"presentation-content","header":"header","footer":"footer","presentation-footer":"presentation-footer"};

/***/ }),

/***/ "gW6S":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"landing-page\"\u003E\u003Cdiv class=\"hero-section section\"\u003E\u003Cdiv class=\"section-container\"\u003E\u003Cdiv class=\"section-content section-split\"\u003E\u003Cdiv class=\"section-text section-item-left\"\u003E\u003Cdiv class=\"section-title\"\u003E\u003Cspan\u003ECollaborative finance in a smart calendar for \u003C\u002Fspan\u003E\u003Cdb-p-word-switcher words=\"['individuals', 'families', 'teams']\" interval=\"3000\"\u003E\u003C\u002Fdb-p-word-switcher\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"hero-buttons\"\u003E\u003Ca class=\"button button-fill button-primary button-sign-up-now\" ui-sref=\"sign-up\"\u003ESign up now\u003C\u002Fa\u003E\u003Ca class=\"button button-outline button-secondary button-download\" ng-if=\"$ctrl.isMobile\" href=\"javascript:void(0);\" ng-href=\"{{ $ctrl.appDownloadUrl }}\" target=\"_blank\" rel=\"noopener\"\u003EDownload\u003C\u002Fa\u003E\u003Cbutton class=\"button button-outline button-secondary button-scroll-to-download\" type=\"button\" ng-if=\"!$ctrl.isMobile\" scroll-to=\"download\"\u003EDownload\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"section-illustration section-item-right\"\u003E\u003Cdiv class=\"section-image\"\u003E\u003Cdiv class=\"section-image-container\"\u003E\u003Cimg" + (" class=\"section-image-source\""+pug.attr("src", __webpack_require__("PeML"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"calendar-section section\"\u003E\u003Cdiv class=\"section-container\"\u003E\u003Cdiv class=\"section-content section-split\"\u003E\u003Cdiv class=\"section-text section-item-right\"\u003E\u003Cdiv class=\"section-title\"\u003ECalendar based personal finance management designed for real life\u003C\u002Fdiv\u003E\u003Cdiv class=\"section-description\"\u003EAdd past, future or recurring transactions and categorize them with a bit of AI help. Track them on mobile and plan ahead on the web, or just mix things up.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"section-illustration section-item-left\"\u003E\u003Cdiv class=\"section-image\"\u003E\u003Cdiv class=\"section-image-container\"\u003E\u003Cimg" + (" class=\"section-image-source\""+pug.attr("src", __webpack_require__("X2Q6"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dashboard-section section\"\u003E\u003Cdiv class=\"section-container\"\u003E\u003Cdiv class=\"section-content section-split\"\u003E\u003Cdiv class=\"section-text section-item-left\"\u003E\u003Cdiv class=\"section-title\"\u003ESee where your money goes and how your balance evolves over time\u003C\u002Fdiv\u003E\u003Cdiv class=\"section-description\"\u003EBe smarter about money. With your balance calculated automatically for each day, month or year, understanding your current and projected financial situation is so easy you might even call it fun.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"section-illustration section-item-right\"\u003E\u003Cdiv class=\"section-image\"\u003E\u003Cdiv class=\"section-image-container\"\u003E\u003Cimg" + (" class=\"section-image-source\""+pug.attr("src", __webpack_require__("t2Si"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"collaboration-section section\"\u003E\u003Cdiv class=\"section-container\"\u003E\u003Cdiv class=\"section-content section-split\"\u003E\u003Cdiv class=\"section-text section-item-right\"\u003E\u003Cdiv class=\"section-title\"\u003EShare calendars to collaborate on joint budgets\u003C\u002Fdiv\u003E\u003Cdiv class=\"section-description\"\u003EAdd your partner, family or team to manage your finances together, and stay up to date with common money matters. \u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"section-illustration section-item-left\"\u003E\u003Cdiv class=\"section-image\"\u003E\u003Cdiv class=\"section-image-container\"\u003E\u003Cimg" + (" class=\"section-image-source\""+pug.attr("src", __webpack_require__("M3T8"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"testimonial-section section\" ng-if=\"$ctrl.testimonials.length &gt; 0\"\u003E\u003Cdiv class=\"section-container\"\u003E\u003Cdiv class=\"section-content\"\u003E\u003Cdiv class=\"section-title\"\u003EWhat our users say about Dollarbird\u003C\u002Fdiv\u003E\u003Cdb-p-testimonial class=\"testimonial-container\" testimonials=\"$ctrl.testimonials\" switch-delay=\"10000\"\u003E\u003C\u002Fdb-p-testimonial\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pricing-section section\" id=\"pricing\"\u003E\u003Cdiv class=\"section-container\"\u003E\u003Cdiv class=\"section-content\"\u003E\u003Cdiv class=\"section-text\"\u003E\u003Cdiv class=\"section-title\"\u003EFind the right plan for you\u003C\u002Fdiv\u003E\u003Cdiv class=\"section-descriptions\"\u003EExplore our monthly and yearly plans and pick the one that best suits your needs.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdb-plans plans=\"$ctrl.plans\" on-select=\"$ctrl.select(plan, subscription)\"\u003E\u003C\u002Fdb-plans\u003E\u003Cdb-loader visible=\"$ctrl.loadingPlans\" overlay=\"true\"\u003E\u003Cdb-pulse-indicator\u003E\u003C\u002Fdb-pulse-indicator\u003E\u003C\u002Fdb-loader\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"download-section section\" id=\"download\"\u003E\u003Cdiv class=\"section-container\"\u003E\u003Cdiv class=\"section-content section-split\"\u003E\u003Cdiv class=\"section-text section-item-right\"\u003E\u003Cdiv class=\"section-title\"\u003EGet Dollarbird now\u003C\u002Fdiv\u003E\u003Cdiv class=\"section-description\"\u003ERecord your transactions on the go with our mobile apps and plan ahead on the web.\u003C\u002Fdiv\u003E\u003Cdiv class=\"download-buttons\"\u003E\u003Ca class=\"button button-download-app\" href=\"javascript:void(0);\" ng-href=\"{{ $ctrl.iosDownloadUrl }}\" target=\"_blank\" rel=\"noopener\"\u003E\u003Cimg" + (" class=\"download-app-image\""+pug.attr("src", __webpack_require__("Es1N"), true, true)+" alt=\"Download from the Apple App Store\"") + "\u003E\u003C\u002Fa\u003E\u003Ca class=\"button button-download-app\" href=\"javascript:void(0);\" ng-href=\"{{ $ctrl.androidDownloadUrl }}\" target=\"_blank\" rel=\"noopener\"\u003E\u003Cimg" + (" class=\"download-app-image\""+pug.attr("src", __webpack_require__("tTca"), true, true)+" alt=\"Download from Google Play Store\"") + "\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"section-illustration section-item-left\"\u003E\u003Cimg" + (" class=\"section-image\""+pug.attr("src", __webpack_require__("HCns"), true, true)+" alt=\"\" role=\"presentation\"") + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"get-started-section section\"\u003E\u003Cdiv class=\"section-container\"\u003E\u003Cdiv class=\"section-content\"\u003E\u003Cdiv class=\"section-title\"\u003EStart your journey towards personal financial freedom.\u003C\u002Fdiv\u003E\u003Ca class=\"button button-fill button-primary button-get-started\" href=\"javascript:void(0);\" ui-sref=\"sign-up\"\u003ESign up now\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "gpPU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracking_style_sass__ = __webpack_require__("sk85");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracking_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__tracking_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracking_tpl_pug__ = __webpack_require__("Wuyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracking_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tracking_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var TrackingController = function () {
    TrackingController.$inject = ['$state'];

    /* @ngInject */
    function TrackingController($state) {
        _classCallCheck(this, TrackingController);

        this.$state = $state;

        this.options = [{
            id: 'spreadsheet',
            title: 'Spreadsheet',
            description: 'I use Excel, Google Sheets, or similar tools',
            icon: 'calendar'
        }, {
            id: 'notes',
            title: 'Notes & Paper',
            description: 'I write down expenses in notes or on paper',
            icon: 'note-add'
        }, {
            id: 'banking',
            title: 'Banking App',
            description: 'I check my bank app or statements',
            icon: 'wallet'
        }, {
            id: 'none',
            title: 'No Tracking',
            description: 'I don\'t track my finances regularly',
            icon: 'help'
        }];
    }

    _createClass(TrackingController, [{
        key: 'selectOption',
        value: function selectOption(option) {
            this.selectedOption = option;
        }
    }, {
        key: 'nextStep',
        value: function nextStep() {
            if (this.selectedOption) {
                this.onSubmit({ questionKey: 'tracking_method', answer: this.selectedOption.id });
                this.$state.go('conversion-quiz.goal');
            }
        }
    }]);

    return TrackingController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    bindings: {
        onSubmit: '&'
    },
    template: __WEBPACK_IMPORTED_MODULE_1__tracking_tpl_pug___default()(),
    controller: TrackingController
});

/***/ }),

/***/ "hNzS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header__ = __webpack_require__("hlcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer__ = __webpack_require__("sph+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__testimonial__ = __webpack_require__("YYwa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__word_switcher__ = __webpack_require__("5nj5");







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('presentation.component', [__WEBPACK_IMPORTED_MODULE_1__header__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__footer__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__testimonial__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__word_switcher__["a" /* default */].name]));

/***/ }),

/***/ "hPqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__landing_style_sass__ = __webpack_require__("wwhX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__landing_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__landing_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__landing_tpl_pug__ = __webpack_require__("gW6S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__landing_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__landing_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var LandingController = function () {
    LandingController.$inject = ['$state', '$window', 'planService', 'configuration'];

    /* @ngInject */
    function LandingController($state, $window, planService, configuration) {
        _classCallCheck(this, LandingController);

        this.$state = $state;
        this.$window = $window;
        this.planService = planService;
        this.configuration = configuration;
    }

    _createClass(LandingController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loadingPlans = true;

            this.planService.getAll().then(function (plans) {
                _this.plans = plans;
            }).finally(function () {
                _this.loadingPlans = false;
            });

            this.appDownloadUrl = this.configuration.appDownloadUrl;
            this.iosDownloadUrl = this.configuration.iosDownloadUrl;
            this.androidDownloadUrl = this.configuration.androidDownloadUrl;
            this.isMobile = !!this.getMobileOperatingSystem();

            this.testimonials = [{
                content: 'Excellent This is exactly what I have been looking for! I don\'t need all of the fancy finance stuff, just a simple way to see what will be in my account each day based on pre-planned bills/expenses. \uD83D\uDE03',
                author: 'Ariel G.'
            }, {
                content: 'This app changed my life. Works great, intuitive, doesn\'t link to your bank account, just easy way to record all your purchases. I love the clean simple design. I\'ve used it nonstop since I downloaded it!!',
                author: 'Emily Pratt B.'
            }, {
                content: 'Every other financial app I\'ve ever tried didn\'t work for me because they are designed for people who make 1 or 2 paychecks a month and don\'t use a lot of cash. As a hairstylist I have various incomes coming in at all different times and bills coming out at all times of the month. This app lets helps me keep it all together! If you\'re looking for a budget app that is designed for real life, I highly recommend you give this one a try!',
                author: 'Whitemistfalls'
            }, {
                content: 'Life Changing I bet other apps can do this too, but Dollarbird happens to be the one that changed my life. In a matter of days I could turn the reminders off, I automatically take out Dollarbird when I spend and especially when I earn now. The detailed feedback on my account makes me save and work alot harder for what\'s mine.',
                author: 'Thijs v. d. H.'
            }, {
                content: 'Great app for tracking spending The app is very efficiently laid out, making it easy to add all transactions quickly.  It\'s very helpful being able to see a breakdown of your spending over time and to see where all your money goes. I use it daily and it has helped me save and account for all my spending.',
                author: 'Josh T.'
            }, {
                content: 'I love this app. It\'s simple yet robust. I like that I do not have to link all of my accounts to track spending. I can input recurring expenses, easily adjust them, and I can budget. I like the future income and expense forecast feature. I\'ve downloaded literally 25 different apps over the years and I continue to use this one with no complaints.',
                author: 'Allene S.'
            }, {
                content: 'Been using @dollarbirdapp for tracking expenses while traveling, and loving every bit of it. simplicity rules! going Pro from April.',
                author: 'Exotic Gringo'
            }, {
                content: 'Never been as comfortable tracking expenses as i am with @dollarbirdapp. don\'t let yourself be fooled by the name. universal app, great ux',
                author: 'Igor S.'
            }];
        }
    }, {
        key: 'select',
        value: function select(plan, subscription) {
            if (plan && plan.id) {
                if (subscription) {
                    if (subscription.id) {
                        return this.$state.go('payment', {
                            plan: plan.id,
                            subscription: subscription ? subscription.id : null
                        });
                    }

                    return this.$state.go('sign-up');
                }

                return this.$window.open('mailto:' + this.configuration.salesEmail, '_self');
            }
        }
    }, {
        key: 'getMobileOperatingSystem',
        value: function getMobileOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone must come first because its UA also contains "Android"
            if (/windows phone/i.test(userAgent)) {
                return 'Windows Phone';
            }

            if (/android/i.test(userAgent)) {
                return 'Android';
            }

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return 'iOS';
            }

            return null;
        }
    }]);

    return LandingController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbPLanding',
    template: __WEBPACK_IMPORTED_MODULE_1__landing_tpl_pug___default()(),
    controller: LandingController
});

/***/ }),

/***/ "hlcP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_component_logo__ = __webpack_require__("EOYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_cmpt__ = __webpack_require__("xRxH");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('presentation.component.header', [__WEBPACK_IMPORTED_MODULE_1_common_component_logo__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_2__header_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__header_cmpt__["a" /* default */]));

/***/ }),

/***/ "hr//":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"suggestion-step":"suggestion-step","subtitle":"subtitle","features-list":"features-list","feature":"feature","feature-icon":"feature-icon","feature-content":"feature-content","btn-primary":"btn-primary"};

/***/ }),

/***/ "mWUN":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("yZbI");
module.exports = 'ngAnimate';


/***/ }),

/***/ "nJlj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_analytics__ = __webpack_require__("3pWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__register_style_sass__ = __webpack_require__("QD74");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__register_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__register_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__register_tpl_pug__ = __webpack_require__("xOrk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__register_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__register_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var RegisterController = function () {
    RegisterController.$inject = ['$state', '$window', 'sessionService', 'paymentService'];

    /* @ngInject */
    function RegisterController($state, $window, sessionService, paymentService) {
        _classCallCheck(this, RegisterController);

        this.$state = $state;
        this.$window = $window;
        this.sessionService = sessionService;
        this.paymentService = paymentService;

        this.user = {
            name: '',
            email: '',
            password: ''
        };
        this.errors = {};
        this.loading = false;
        this.loadingMessage = '';
    }

    _createClass(RegisterController, [{
        key: 'validateForm',
        value: function validateForm() {
            this.errors = {};
            var isValid = true;

            if (!this.user.name) {
                this.errors.name = 'Name is required';
                isValid = false;
            }

            if (!this.user.email) {
                this.errors.email = 'Email is required';
                isValid = false;
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.user.email)) {
                this.errors.email = 'Please enter a valid email';
                isValid = false;
            }

            if (!this.user.password) {
                this.errors.password = 'Password is required';
                isValid = false;
            } else if (this.user.password.length < 8) {
                this.errors.password = 'Password must be at least 8 characters';
                isValid = false;
            }

            return isValid;
        }
    }, {
        key: 'register',
        value: function register() {
            var _this = this;

            if (this.validateForm()) {
                this.loading = true;
                this.errors = {};

                // First sign up the user
                this.sessionService.signUp(this.user.name, this.user.email, this.user.password).then(function () {
                    __WEBPACK_IMPORTED_MODULE_0_common_analytics__["c" /* default */].trackSignUp();

                    // Save registration info
                    _this.onSubmit({
                        questionKey: 'registration',
                        answer: {
                            name: _this.user.name,
                            email: _this.user.email
                        }
                    });

                    // Go directly to download
                    _this.$state.go('conversion-quiz.download');
                }).catch(function (error) {
                    var errorMessage = void 0;
                    if (error && error.data && error.data.error) {
                        errorMessage = error.data.error;
                    } else if (error && error.message) {
                        errorMessage = error.message;
                    } else if (error && typeof error === 'string') {
                        errorMessage = error;
                    } else {
                        errorMessage = 'An unexpected error occurred';
                    }

                    _this.loading = false;
                    _this.errors.general = errorMessage;
                });
            }
        }
    }]);

    return RegisterController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    template: __WEBPACK_IMPORTED_MODULE_2__register_tpl_pug___default()(),
    controller: RegisterController,
    bindings: {
        answers: '<',
        onSubmit: '&'
    },
    require: {
        quiz: '^dbConversionQuiz'
    }
});

/***/ }),

/***/ "pYrq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common__ = __webpack_require__("1lyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__landing__ = __webpack_require__("VgOx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conversion_quiz__ = __webpack_require__("cW+L");
stateConfiguration.$inject = ['$stateProvider'];







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('presentation.scene', [__WEBPACK_IMPORTED_MODULE_2__landing__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__conversion_quiz__["a" /* default */].name]).config(stateConfiguration));

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('sign-in', {
        url: Object(__WEBPACK_IMPORTED_MODULE_1_common__["g" /* getApplicationStateUrl */])(__WEBPACK_IMPORTED_MODULE_1_common__["c" /* URL_SIGN_IN */]),
        data: {
            external: true
        }
    }).state('sign-up', {
        url: Object(__WEBPACK_IMPORTED_MODULE_1_common__["g" /* getApplicationStateUrl */])(__WEBPACK_IMPORTED_MODULE_1_common__["d" /* URL_SIGN_UP */]),
        data: {
            external: true
        }
    }).state('payment', {
        url: Object(__WEBPACK_IMPORTED_MODULE_1_common__["g" /* getApplicationStateUrl */])(__WEBPACK_IMPORTED_MODULE_1_common__["a" /* URL_PAYMENT */]),
        data: {
            external: true
        }
    }).state('privacy-policy', {
        url: Object(__WEBPACK_IMPORTED_MODULE_1_common__["h" /* getLegalStateUrl */])(__WEBPACK_IMPORTED_MODULE_1_common__["b" /* URL_PRIVACY_POLICY */]),
        data: {
            external: {
                blank: true
            }
        }
    }).state('terms-of-service', {
        url: Object(__WEBPACK_IMPORTED_MODULE_1_common__["h" /* getLegalStateUrl */])(__WEBPACK_IMPORTED_MODULE_1_common__["e" /* URL_TERMS_OF_SERVICE */]),
        data: {
            external: {
                blank: true
            }
        }
    });
}

/***/ }),

/***/ "pwjX":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"quiz-step plans-step\"\u003E\u003Ch2\u003EChoose Your Plan\u003C\u002Fh2\u003E\u003Cp class=\"subtitle\"\u003ESelect the plan that works best for you\u003C\u002Fp\u003E\u003Cdiv class=\"loading-state\" ng-if=\"$ctrl.loading\"\u003E\u003Cdiv class=\"spinner\"\u003E\u003Ci class=\"icon icon-dollarbird-loading\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003Cp\u003ELoading available plans...\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"plan-types\" ng-if=\"!$ctrl.loading\"\u003E\u003Cdiv class=\"plan-type\" ng-repeat=\"type in ['Pro', 'Pro Unlimited']\"\u003E\u003Ch3 class=\"type-title\" style=\"color: {{($ctrl.plans | filter:{type:type}:true)[0].color}}\"\u003E{{type}}\u003C\u002Fh3\u003E\u003Cdiv class=\"options\"\u003E\u003Cdiv class=\"option\" ng-repeat=\"plan in $ctrl.plans | filter:{type:type}:true\" ng-class=\"{ selected: $ctrl.selectedPlan === plan, recommended: plan.recommended }\" ng-click=\"$ctrl.selectPlan(plan)\" style=\"--plan-color: {{plan.color}}\"\u003E\u003Cdiv class=\"badge\" ng-if=\"plan.recommended\"\u003ERECOMMENDED\u003C\u002Fdiv\u003E\u003Cdiv class=\"option-text\"\u003E\u003Ch3\u003E{{plan.name}}\u003C\u002Fh3\u003E\u003Cdiv class=\"price\"\u003E\u003Cspan class=\"amount\"\u003E{{plan.price}}\u003C\u002Fspan\u003E\u003Cspan class=\"period\"\u003E{{plan.period}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"savings\" ng-if=\"plan.savings\"\u003E{{plan.savings}}\u003C\u002Fdiv\u003E\u003Cul class=\"features\"\u003E\u003Cli ng-repeat=\"feature in plan.features\"\u003E\u003Ci class=\"icon icon-dollarbird-check\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003E{{feature}}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"$ctrl.nextStep()\" ng-disabled=\"!$ctrl.selectedPlan\"\u003E NEXT\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "q3yg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__suggestion_style_sass__ = __webpack_require__("hr//");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__suggestion_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__suggestion_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__suggestion_tpl_pug__ = __webpack_require__("+FuK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__suggestion_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__suggestion_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var SuggestionController = function () {
    SuggestionController.$inject = ['$state'];

    /* @ngInject */
    function SuggestionController($state) {
        _classCallCheck(this, SuggestionController);

        this.$state = $state;
        this.features = [{
            id: 'calendar',
            title: 'Smart calendar',
            description: 'Track your finances in a familiar calendar view',
            icon: 'calendar'
        }, {
            id: 'quick-entry',
            title: 'Quick entry',
            description: 'Add expenses with a few taps and have our AI automatically categorize them',
            icon: 'note-add'
        }, {
            id: 'collaborate',
            title: 'Collaborate with your partner',
            description: 'Track expenses in a shared calendar',
            icon: 'users'
        }, {
            id: 'multiplatform',
            title: 'Multiplatform',
            description: 'Use your phone to add expenses and your computer when planning',
            icon: 'devices'
        }];
    }

    _createClass(SuggestionController, [{
        key: 'continueToRegister',
        value: function continueToRegister() {
            this.onSubmit({ questionKey: 'features_shown', answer: true });
            this.$state.go('conversion-quiz.register');
        }
    }]);

    return SuggestionController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    template: __WEBPACK_IMPORTED_MODULE_1__suggestion_tpl_pug___default()(),
    controller: SuggestionController,
    bindings: {
        onSubmit: '&'
    }
});

/***/ }),

/***/ "qcJx":
/***/ (function(module, exports) {

/*!
 *	 Angular Smooth Scroll (ngSmoothScroll)
 *	 Animates scrolling to elements, by David Oliveros.
 *
 *   Callback hooks contributed by Ben Armston https://github.com/benarmston
 *	 Easing support contributed by Willem Liu. https://github.com/willemliu
 *	 Easing functions forked from Gaëtan Renaudeau. https://gist.github.com/gre/1650294
 *	 Infinite loop bugs in iOS and Chrome (when zoomed) by Alex Guzman. https://github.com/alexguzman
 *	 Support for scrolling in custom containers by Joseph Matthias Goh. https://github.com/zephinzer
 *	 Influenced by Chris Ferdinandi
 *	 https://github.com/cferdinandi
 *
 *	 Version: 2.0.0
 * 	 License: MIT
 */

(function () {
	'use strict';

	var module = angular.module('smoothScroll', []);


	/**
	 * Smooth scrolls the window/div to the provided element.
	 *
	 * 20150713 EDIT - zephinzer
	 * 	Added new option - containerId to account for scrolling within a DIV
	 */
	var smoothScroll = function (element, options) {
		options = options || {};

		// Options
		var duration = options.duration || 800,
			offset = options.offset || 0,
			easing = options.easing || 'easeInOutQuart',
			callbackBefore = options.callbackBefore || function() {},
			callbackAfter = options.callbackAfter || function() {},
			container = document.getElementById(options.containerId) || null,
			containerPresent = (container != undefined && container != null);

		/**
		 * Retrieve current location
		 */
		var getScrollLocation = function() {
			if(containerPresent) {
				return container.scrollTop;
			} else {
				if(window.pageYOffset) {
					return window.pageYOffset;
				} else {
					return document.documentElement.scrollTop;
				}
			}
		};

		/**
		 * Calculate easing pattern.
		 *
		 * 20150713 edit - zephinzer
		 * - changed if-else to switch
		 * @see http://archive.oreilly.com/pub/a/server-administration/excerpts/even-faster-websites/writing-efficient-javascript.html
		 */
		var getEasingPattern = function(type, time) {
			switch(type) {
				case 'easeInQuad': 		return time * time; // accelerating from zero velocity
				case 'easeOutQuad': 	return time * (2 - time); // decelerating to zero velocity
				case 'easeInOutQuad': 	return time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time; // acceleration until halfway, then deceleration
				case 'easeInCubic': 	return time * time * time; // accelerating from zero velocity
				case 'easeOutCubic': 	return (--time) * time * time + 1; // decelerating to zero velocity
				case 'easeInOutCubic': 	return time < 0.5 ? 4 * time * time * time : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1; // acceleration until halfway, then deceleration
				case 'easeInQuart': 	return time * time * time * time; // accelerating from zero velocity
				case 'easeOutQuart': 	return 1 - (--time) * time * time * time; // decelerating to zero velocity
				case 'easeInOutQuart': 	return time < 0.5 ? 8 * time * time * time * time : 1 - 8 * (--time) * time * time * time; // acceleration until halfway, then deceleration
				case 'easeInQuint': 	return time * time * time * time * time; // accelerating from zero velocity
				case 'easeOutQuint': 	return 1 + (--time) * time * time * time * time; // decelerating to zero velocity
				case 'easeInOutQuint': 	return time < 0.5 ? 16 * time * time * time * time * time : 1 + 16 * (--time) * time * time * time * time; // acceleration until halfway, then deceleration
				default:				return time;
			}
		};

		/**
		 * Calculate how far to scroll
		 */
		var getEndLocation = function(element) {
			var location = 0;
			if (element.offsetParent) {
				do {
					location += element.offsetTop;
					element = element.offsetParent;
				} while (element);
			}
			location = Math.max(location - offset, 0);
			return location;
		};

		// Initialize the whole thing
		setTimeout( function() {
			var currentLocation = null,
				startLocation 	= getScrollLocation(),
				endLocation 	= getEndLocation(element),
				timeLapsed 		= 0,
				distance 		= endLocation - startLocation,
				percentage,
				position,
				scrollHeight,
				internalHeight;

			/**
			 * Stop the scrolling animation when the anchor is reached (or at the top/bottom of the page)
			 */
			var stopAnimation = function () {
				currentLocation = getScrollLocation();
				if(containerPresent) {
					scrollHeight = container.scrollHeight;
					internalHeight = container.clientHeight + currentLocation;
				} else {
					scrollHeight = document.body.scrollheight;
					internalHeight = window.innerHeight + currentLocation;
				}

				if (
					( // condition 1
						position == endLocation
					) ||
					( // condition 2
						currentLocation == endLocation
					) ||
					( // condition 3
						internalHeight >= scrollHeight
					)
				) { // stop
					clearInterval(runAnimation);
					callbackAfter(element);
				}
			};

			/**
			 * Scroll the page by an increment, and check if it's time to stop
			 */
			var animateScroll = function () {
				timeLapsed += 16;
				percentage = ( timeLapsed / duration );
				percentage = ( percentage > 1 ) ? 1 : percentage;
				position = startLocation + ( distance * getEasingPattern(easing, percentage) );
				if(containerPresent) {
					container.scrollTop = position;
				} else {
					window.scrollTo( 0, position );
				}
				stopAnimation();
			};

			callbackBefore(element);
			var runAnimation = setInterval(animateScroll, 16);
		}, 0);
	};


	// Expose the library in a factory
	//
	module.factory('smoothScroll', function() {
		return smoothScroll;
	});


	/**
	 * Scrolls the window to this element, optionally validating an expression
	 *
	 * 20150713 EDIT - zephinzer
	 * 	Added containerId to attributes for smooth scrolling within a DIV
	 */
	module.directive('smoothScroll', ['smoothScroll', function(smoothScroll) {
		return {
			restrict: 'A',
			scope: {
				callbackBefore: '&',
				callbackAfter: '&',
			},
			link: function($scope, $elem, $attrs) {
				if ( typeof $attrs.scrollIf === 'undefined' || $attrs.scrollIf === 'true' ) {
					setTimeout( function() {

						var callbackBefore = function(element) {
							if ( $attrs.callbackBefore ) {
								var exprHandler = $scope.callbackBefore({ element: element });
								if (typeof exprHandler === 'function') {
									exprHandler(element);
								}
							}
						};

						var callbackAfter = function(element) {
							if ( $attrs.callbackAfter ) {
								var exprHandler = $scope.callbackAfter({ element: element });
								if (typeof exprHandler === 'function') {
									exprHandler(element);
								}
							}
						};

						smoothScroll($elem[0], {
							duration: $attrs.duration,
							offset: $attrs.offset,
							easing: $attrs.easing,
							callbackBefore: callbackBefore,
							callbackAfter: callbackAfter,
							containerId: $attrs.containerId
						});
					}, 0);
				}
			}
		};
	}]);


	/**
	 * Scrolls to a specified element ID when this element is clicked
	 *
	 * 20150713 EDIT - zephinzer
	 * 	Added containerId to attributes for smooth scrolling within a DIV
	 */
	module.directive('scrollTo', ['smoothScroll', function(smoothScroll) {
		return {
			restrict: 'A',
			scope: {
				callbackBefore: '&',
				callbackAfter: '&',
			},
			link: function($scope, $elem, $attrs) {
				var targetElement;

				$elem.on('click', function(e) {
					e.preventDefault();

					targetElement = document.getElementById($attrs.scrollTo);
					if ( !targetElement ) return;

					// adding focus to the lement to improve accesibility
          targetElement.focus();

					var callbackBefore = function(element) {
						if ( $attrs.callbackBefore ) {
							var exprHandler = $scope.callbackBefore({element: element});
							if (typeof exprHandler === 'function') {
								exprHandler(element);
							}
						}
					};

					var callbackAfter = function(element) {
						if ( $attrs.callbackAfter ) {
							var exprHandler = $scope.callbackAfter({element: element});
							if (typeof exprHandler === 'function') {
								exprHandler(element);
							}
						}
					};

					smoothScroll(targetElement, {
						duration: $attrs.duration,
						offset: $attrs.offset,
						easing: $attrs.easing,
						callbackBefore: callbackBefore,
						callbackAfter: callbackAfter,
						containerId: $attrs.containerId
					});

					return false;
				});
			}
		};
	}]);

}());

/***/ }),

/***/ "sQr7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__goal_style_sass__ = __webpack_require__("zApV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__goal_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__goal_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__goal_tpl_pug__ = __webpack_require__("HDkY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__goal_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__goal_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var GoalController = function () {
    GoalController.$inject = ['$state'];

    /* @ngInject */
    function GoalController($state) {
        _classCallCheck(this, GoalController);

        this.$state = $state;
        this.selectedGoals = [];
        this.goals = [{
            id: 'debt',
            title: 'Get Out of Debt',
            description: 'Take control of your debt and create a plan to become debt-free'
        }, {
            id: 'savings',
            title: 'Build Savings',
            description: 'Create an emergency fund or save for big purchases'
        }, {
            id: 'house',
            title: 'Buy a House',
            description: 'Save for a down payment and plan for homeownership'
        }, {
            id: 'retirement',
            title: 'Plan Retirement',
            description: 'Prepare for a comfortable retirement and track investments'
        }, {
            id: 'vacation',
            title: 'Travel & Vacation',
            description: 'Save for your dream vacation or travel adventures'
        }, {
            id: 'car',
            title: 'Buy a Car',
            description: 'Save for a new car or manage car-related expenses'
        }];
    }

    _createClass(GoalController, [{
        key: 'selectGoal',
        value: function selectGoal(goal) {
            var index = this.selectedGoals.indexOf(goal);
            if (index === -1) {
                this.selectedGoals.push(goal);
            } else {
                this.selectedGoals.splice(index, 1);
            }
        }
    }, {
        key: 'isSelected',
        value: function isSelected(goal) {
            return this.selectedGoals.includes(goal);
        }
    }, {
        key: 'nextStep',
        value: function nextStep() {
            if (this.selectedGoals.length > 0) {
                this.onSubmit({
                    questionKey: 'financial_goals',
                    answer: this.selectedGoals.map(function (goal) {
                        return goal.id;
                    })
                });
                this.$state.go('conversion-quiz.suggestion');
            }
        }
    }]);

    return GoalController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    template: __WEBPACK_IMPORTED_MODULE_1__goal_tpl_pug___default()(),
    controller: GoalController,
    bindings: {
        onSubmit: '&'
    }
});

/***/ }),

/***/ "sk85":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tracking-step":"tracking-step","subtitle":"subtitle","options":"options","option":"option","option-text":"option-text","selected":"selected","btn-primary":"btn-primary","icon":"icon"};

/***/ }),

/***/ "sph+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_component_logo__ = __webpack_require__("EOYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_cmpt__ = __webpack_require__("IMCk");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('presentation.component.footer', [__WEBPACK_IMPORTED_MODULE_1_common_component_logo__["a" /* default */].name]).component(__WEBPACK_IMPORTED_MODULE_2__footer_cmpt__["a" /* default */].selector, __WEBPACK_IMPORTED_MODULE_2__footer_cmpt__["a" /* default */]));

/***/ }),

/***/ "t+np":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__("/jXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uirouter_angularjs__ = __webpack_require__("7Cuf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular_animate__ = __webpack_require__("mWUN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angular_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ngSmoothScroll__ = __webpack_require__("qcJx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ngSmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ngSmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_site_style_sass__ = __webpack_require__("dvC6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_site_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_site_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common__ = __webpack_require__("1lyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__("hNzS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scene__ = __webpack_require__("pYrq");
routerConfiguration.$inject = ['$locationProvider', '$urlRouterProvider'];











/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.module('presentation', [__WEBPACK_IMPORTED_MODULE_1__uirouter_angularjs__["default"], __WEBPACK_IMPORTED_MODULE_2_angular_animate___default.a, 'smoothScroll', __WEBPACK_IMPORTED_MODULE_5_common__["f" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__scene__["a" /* default */].name]).config(routerConfiguration));

/* @ngInject */
function routerConfiguration($locationProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);

    // Ensure /start and /start/ redirect to /start/welcome before any other rules
    $urlRouterProvider.when('/start', '/start/welcome');
    $urlRouterProvider.when('/start/', '/start/welcome');

    // Default route
    $urlRouterProvider.otherwise('/');
}

/***/ }),

/***/ "t2Si":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-dashboard-screenshot-9a768ccab871ce99.png";

/***/ }),

/***/ "tTca":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/image-google-play-download-101601e3b08a2a82.png";

/***/ }),

/***/ "w9zy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"welcome-step":"welcome-step","btn-primary":"btn-primary"};

/***/ }),

/***/ "wwhX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"landing-page":"landing-page","button-sign-up-now":"button-sign-up-now","button-download":"button-download","button-scroll-to-download":"button-scroll-to-download","button-get-started":"button-get-started","section":"section","section-container":"section-container","section-title":"section-title","section-description":"section-description","section-split":"section-split","section-text":"section-text","section-illustration":"section-illustration","section-item-left":"section-item-left","section-item-right":"section-item-right","section-image":"section-image","section-image-container":"section-image-container","section-image-source":"section-image-source","hero-section":"hero-section","hero-buttons":"hero-buttons","calendar-section":"calendar-section","dashboard-section":"dashboard-section","collaboration-section":"collaboration-section","testimonial-section":"testimonial-section","testimonial-container":"testimonial-container","pricing-section":"pricing-section","download-section":"download-section","download-buttons":"download-buttons","button-download-app":"button-download-app","download-app-image":"download-app-image","get-started-section":"get-started-section","word-switch":"word-switch"};

/***/ }),

/***/ "xOGg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__struggles_style_sass__ = __webpack_require__("c00M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__struggles_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__struggles_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__struggles_tpl_pug__ = __webpack_require__("1i11");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__struggles_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__struggles_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var StrugglesController = function () {
    StrugglesController.$inject = ['$state'];

    /* @ngInject */
    function StrugglesController($state) {
        _classCallCheck(this, StrugglesController);

        this.$state = $state;
        this.selectedOptions = [];
        this.options = [{
            id: 'debt',
            text: 'Getting out of debt',
            icon: 'wallet'
        }, {
            id: 'unexpected',
            text: 'Covering unexpected expenses',
            icon: 'calendar'
        }, {
            id: 'family',
            text: 'Managing family finances',
            icon: 'users'
        }, {
            id: 'saving',
            text: 'Saving for bigger expenses',
            icon: 'note-add'
        }, {
            id: 'retirement',
            text: 'Planning for retirement',
            icon: 'chart'
        }];
    }

    _createClass(StrugglesController, [{
        key: 'toggleOption',
        value: function toggleOption(option) {
            var index = this.selectedOptions.indexOf(option);
            if (index === -1) {
                this.selectedOptions.push(option);
            } else {
                this.selectedOptions.splice(index, 1);
            }
        }
    }, {
        key: 'nextStep',
        value: function nextStep() {
            if (this.selectedOptions.length > 0) {
                this.onSubmit({
                    questionKey: 'struggles',
                    answer: this.selectedOptions.map(function (opt) {
                        return opt.id;
                    })
                });
                this.$state.go('conversion-quiz.tracking');
            }
        }
    }]);

    return StrugglesController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    template: __WEBPACK_IMPORTED_MODULE_1__struggles_tpl_pug___default()(),
    controller: StrugglesController,
    bindings: {
        onSubmit: '&'
    }
});

/***/ }),

/***/ "xOrk":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"quiz-step register-step\"\u003E\u003Ch2\u003ECreate Your Account\u003C\u002Fh2\u003E\u003Cp class=\"subtitle\"\u003ELet's create a Dollarbird account to save your preferences and start you on your path to financial peace of mind.\u003C\u002Fp\u003E\u003Cdiv class=\"error-message general\" ng-if=\"$ctrl.errors.general\"\u003E{{$ctrl.errors.general}}\u003C\u002Fdiv\u003E\u003Cform ng-submit=\"$ctrl.register(); $event.preventDefault()\"\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel for=\"name\"\u003EName\u003C\u002Flabel\u003E\u003Cinput id=\"name\" type=\"text\" ng-model=\"$ctrl.user.name\" placeholder=\"Enter your name\" ng-class=\"{ error: $ctrl.errors.name }\" ng-disabled=\"$ctrl.loading\"\u003E\u003Cdiv class=\"error-message\" ng-if=\"$ctrl.errors.name\"\u003E{{$ctrl.errors.name}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel for=\"email\"\u003EEmail\u003C\u002Flabel\u003E\u003Cinput id=\"email\" type=\"email\" ng-model=\"$ctrl.user.email\" placeholder=\"Enter your email\" ng-class=\"{ error: $ctrl.errors.email }\" ng-disabled=\"$ctrl.loading\" autocomplete=\"username\"\u003E\u003Cdiv class=\"error-message\" ng-if=\"$ctrl.errors.email\"\u003E{{$ctrl.errors.email}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Clabel for=\"password\"\u003EPassword\u003C\u002Flabel\u003E\u003Cinput id=\"password\" type=\"password\" ng-model=\"$ctrl.user.password\" placeholder=\"Choose a password (min. 8 characters)\" ng-class=\"{ error: $ctrl.errors.password }\" ng-disabled=\"$ctrl.loading\" data-dashlane-rid=\"93e2109a5c48e3b4\" data-dashlane-classification=\"password,new\" autocomplete=\"new-password\"\u003E\u003Cdiv class=\"error-message\" ng-if=\"$ctrl.errors.password\"\u003E{{$ctrl.errors.password}}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-actions\"\u003E\u003Cbutton class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"$ctrl.loading\"\u003E\u003Cspan ng-if=\"!$ctrl.loading\"\u003ECreate Account\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.loading\"\u003E\u003Ci class=\"icon icon-dollarbird-loading\"\u003E\u003C\u002Fi\u003E{{$ctrl.loadingMessage || 'Creating Account...'}}\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "xRxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_style_sass__ = __webpack_require__("zeJd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_tpl_pug__ = __webpack_require__("Op+b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header_tpl_pug__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var HeaderController = function () {
    HeaderController.$inject = ['$state'];

    /* @ngInject */
    function HeaderController($state) {
        _classCallCheck(this, HeaderController);

        this.$state = $state;
    }

    _createClass(HeaderController, [{
        key: 'toggleNavigation',
        value: function toggleNavigation() {
            this.navigationVisible = !this.navigationVisible;
        }
    }, {
        key: 'closeNavigation',
        value: function closeNavigation() {
            this.navigationVisible = false;
        }
    }]);

    return HeaderController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbPHeader',
    template: __WEBPACK_IMPORTED_MODULE_1__header_tpl_pug___default()(),
    controller: HeaderController
});

/***/ }),

/***/ "xhR+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce__ = __webpack_require__("M+Z9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__testimonial_style_sass__ = __webpack_require__("I2sI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__testimonial_style_sass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__testimonial_style_sass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__testimonial_tpl_pug__ = __webpack_require__("LBM7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__testimonial_tpl_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__testimonial_tpl_pug__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var TestimonialController = function () {
    TestimonialController.$inject = ['$interval'];

    /* @ngInject */
    function TestimonialController($interval) {
        _classCallCheck(this, TestimonialController);

        this.$interval = $interval;
    }

    _createClass(TestimonialController, [{
        key: '$onInit',
        value: function $onInit() {
            this.current = 0;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changeObject) {
            if (changeObject.testimonials) {
                this.testimonial = __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default()(this.testimonials, function (longest, testimonial) {
                    return !longest || !longest.content || longest.content.length < testimonial.content.length ? testimonial : longest;
                }, null);
            }
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.stopAutomaticCycle();
        }
    }, {
        key: 'select',
        value: function select(index) {
            this.current = index;
        }
    }, {
        key: 'selectPrevious',
        value: function selectPrevious() {
            return this.select(this.current - 1);
        }
    }, {
        key: 'selectNext',
        value: function selectNext() {
            return this.select(this.current + 1);
        }
    }, {
        key: 'startAutomaticCycle',
        value: function startAutomaticCycle() {
            this.switchIntervalId = this.$interval(this.selectNext.bind(this), this.switchDelay || 5000);
        }
    }, {
        key: 'stopAutomaticCycle',
        value: function stopAutomaticCycle() {
            this.$interval.cancel(this.switchIntervalId);
        }
    }, {
        key: 'current',
        get: function get() {
            return this._current;
        },
        set: function set(value) {
            this.stopAutomaticCycle();

            value = value >= 0 ? value % this.testimonials.length : (this.testimonials.length + value) % this.testimonials.length;

            if (this._current != null) {
                if (this._current < value) {
                    this.leftIn = null;
                    this.leftOut = this._current;
                    this.rightIn = value;
                    this.rightOut = null;
                } else if (this._current > value) {
                    this.leftIn = value;
                    this.leftOut = null;
                    this.rightOut = this._current;
                    this.rightIn = null;
                }
            }

            this._current = value;

            this.startAutomaticCycle();
        }
    }]);

    return TestimonialController;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
    selector: 'dbPTestimonial',
    template: __WEBPACK_IMPORTED_MODULE_2__testimonial_tpl_pug___default()(),
    controller: TestimonialController,
    bindings: {
        testimonials: '<',
        switchDelay: '<'
    }
});

/***/ }),

/***/ "xuSX":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"quiz-step welcome-step\"\u003E\u003Ch2\u003EReady to take your family finances to the next level?\u003C\u002Fh2\u003E\u003Cp class=\"subtitle\"\u003ETake our quick quiz to see if Dollarbird can help you achieve your financial goals.\u003C\u002Fp\u003E\u003Cbutton class=\"btn btn-primary\" ng-click=\"$ctrl.startQuiz()\"\u003E TAKE THE QUIZ\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "xvAI":
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__("coDY");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cfooter class=\"footer\"\u003E\u003Cdiv class=\"footer-content\"\u003E\u003Cdiv class=\"footer-logo-container\"\u003E\u003Ca class=\"footer-logo\" ui-sref=\"landing\" target=\"_self\"\u003E\u003Cdb-logo\u003E\u003C\u002Fdb-logo\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cnav class=\"legal-container\"\u003E\u003Cdiv class=\"navigation-item-container\"\u003E\u003Ca class=\"navigation-item\" href=\"javascript:void(0);\" ui-sref=\"privacy-policy\"\u003EPrivacy Policy\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navigation-item-container\"\u003E\u003Ca class=\"navigation-item\" href=\"javascript:void(0);\" ui-sref=\"terms-of-service\"\u003ETerms of Service\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navigation-item-container\"\u003E\u003Ca class=\"navigation-item\" href=\"javascript:void(0);\" ng-href=\"{{ $ctrl.helpCenterUrl }}\" target=\"_blank\" rel=\"noopener\"\u003EHelp Center\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"navigation-item-container\"\u003E\u003Ca class=\"navigation-item\" href=\"javascript:void(0);\" ng-href=\"{{ $ctrl.pressKitUrl }}\" target=\"_blank\" rel=\"noopener\"\u003EPress Kit\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003Cnav class=\"contact-container\"\u003E\u003Cdiv class=\"email-container navigation-item-container\"\u003E\u003Ca class=\"navigation-item\" db-mail-to=\"$ctrl.salesEmail\" target=\"_blank\" rel=\"noopener\" ng-bind=\"$ctrl.salesEmail\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"social-container\"\u003E\u003Ca class=\"navigation-item\" href=\"javascript:void(0);\" ng-href=\"{{ $ctrl.facebookUrl }}\" target=\"_blank\" rel=\"noopener\"\u003E\u003Ci class=\"icon icon-dollarbird-facebook\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Ca class=\"navigation-item\" href=\"javascript:void(0);\" ng-href=\"{{ $ctrl.twitterUrl }}\" target=\"_blank\" rel=\"noopener\"\u003E\u003Ci class=\"icon icon-dollarbird-twitter\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffooter\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ "yZbI":
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var ELEMENT_NODE = 1;
var COMMENT_NODE = 8;

var ADD_CLASS_SUFFIX = '-add';
var REMOVE_CLASS_SUFFIX = '-remove';
var EVENT_CLASS_PREFIX = 'ng-';
var ACTIVE_CLASS_SUFFIX = '-active';
var PREPARE_CLASS_SUFFIX = '-prepare';

var NG_ANIMATE_CLASSNAME = 'ng-animate';
var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';

// Detect proper transitionend/animationend event names.
var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;

// If unprefixed events are not supported but webkit-prefixed are, use the latter.
// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
// Register both events in case `window.onanimationend` is not supported because of that,
// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
// therefore there is no reason to test anymore for other vendor prefixes:
// http://caniuse.com/#search=transition
if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  TRANSITION_PROP = 'WebkitTransition';
  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
} else {
  TRANSITION_PROP = 'transition';
  TRANSITIONEND_EVENT = 'transitionend';
}

if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  ANIMATION_PROP = 'WebkitAnimation';
  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
} else {
  ANIMATION_PROP = 'animation';
  ANIMATIONEND_EVENT = 'animationend';
}

var DURATION_KEY = 'Duration';
var PROPERTY_KEY = 'Property';
var DELAY_KEY = 'Delay';
var TIMING_KEY = 'TimingFunction';
var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
var ANIMATION_PLAYSTATE_KEY = 'PlayState';
var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;

var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;

var ngMinErr = angular.$$minErr('ng');
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function packageStyles(options) {
  var styles = {};
  if (options && (options.to || options.from)) {
    styles.to = options.to;
    styles.from = options.from;
  }
  return styles;
}

function pendClasses(classes, fix, isPrefix) {
  var className = '';
  classes = isArray(classes)
      ? classes
      : classes && isString(classes) && classes.length
          ? classes.split(/\s+/)
          : [];
  forEach(classes, function(klass, i) {
    if (klass && klass.length > 0) {
      className += (i > 0) ? ' ' : '';
      className += isPrefix ? fix + klass
                            : klass + fix;
    }
  });
  return className;
}

function removeFromArray(arr, val) {
  var index = arr.indexOf(val);
  if (val >= 0) {
    arr.splice(index, 1);
  }
}

function stripCommentsFromElement(element) {
  if (element instanceof jqLite) {
    switch (element.length) {
      case 0:
        return element;

      case 1:
        // there is no point of stripping anything if the element
        // is the only element within the jqLite wrapper.
        // (it's important that we retain the element instance.)
        if (element[0].nodeType === ELEMENT_NODE) {
          return element;
        }
        break;

      default:
        return jqLite(extractElementNode(element));
    }
  }

  if (element.nodeType === ELEMENT_NODE) {
    return jqLite(element);
  }
}

function extractElementNode(element) {
  if (!element[0]) return element;
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function $$addClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.addClass(elm, className);
  });
}

function $$removeClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.removeClass(elm, className);
  });
}

function applyAnimationClassesFactory($$jqLite) {
  return function(element, options) {
    if (options.addClass) {
      $$addClass($$jqLite, element, options.addClass);
      options.addClass = null;
    }
    if (options.removeClass) {
      $$removeClass($$jqLite, element, options.removeClass);
      options.removeClass = null;
    }
  };
}

function prepareAnimationOptions(options) {
  options = options || {};
  if (!options.$$prepared) {
    var domOperation = options.domOperation || noop;
    options.domOperation = function() {
      options.$$domOperationFired = true;
      domOperation();
      domOperation = noop;
    };
    options.$$prepared = true;
  }
  return options;
}

function applyAnimationStyles(element, options) {
  applyAnimationFromStyles(element, options);
  applyAnimationToStyles(element, options);
}

function applyAnimationFromStyles(element, options) {
  if (options.from) {
    element.css(options.from);
    options.from = null;
  }
}

function applyAnimationToStyles(element, options) {
  if (options.to) {
    element.css(options.to);
    options.to = null;
  }
}

function mergeAnimationDetails(element, oldAnimation, newAnimation) {
  var target = oldAnimation.options || {};
  var newOptions = newAnimation.options || {};

  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);

  if (newOptions.preparationClasses) {
    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
    delete newOptions.preparationClasses;
  }

  // noop is basically when there is no callback; otherwise something has been set
  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;

  extend(target, newOptions);

  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
  if (realDomOperation) {
    target.domOperation = realDomOperation;
  }

  if (classes.addClass) {
    target.addClass = classes.addClass;
  } else {
    target.addClass = null;
  }

  if (classes.removeClass) {
    target.removeClass = classes.removeClass;
  } else {
    target.removeClass = null;
  }

  oldAnimation.addClass = target.addClass;
  oldAnimation.removeClass = target.removeClass;

  return target;
}

function resolveElementClasses(existing, toAdd, toRemove) {
  var ADD_CLASS = 1;
  var REMOVE_CLASS = -1;

  var flags = {};
  existing = splitClassesToLookup(existing);

  toAdd = splitClassesToLookup(toAdd);
  forEach(toAdd, function(value, key) {
    flags[key] = ADD_CLASS;
  });

  toRemove = splitClassesToLookup(toRemove);
  forEach(toRemove, function(value, key) {
    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
  });

  var classes = {
    addClass: '',
    removeClass: ''
  };

  forEach(flags, function(val, klass) {
    var prop, allow;
    if (val === ADD_CLASS) {
      prop = 'addClass';
      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
    } else if (val === REMOVE_CLASS) {
      prop = 'removeClass';
      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
    }
    if (allow) {
      if (classes[prop].length) {
        classes[prop] += ' ';
      }
      classes[prop] += klass;
    }
  });

  function splitClassesToLookup(classes) {
    if (isString(classes)) {
      classes = classes.split(' ');
    }

    var obj = {};
    forEach(classes, function(klass) {
      // sometimes the split leaves empty string values
      // incase extra spaces were applied to the options
      if (klass.length) {
        obj[klass] = true;
      }
    });
    return obj;
  }

  return classes;
}

function getDomNode(element) {
  return (element instanceof jqLite) ? element[0] : element;
}

function applyGeneratedPreparationClasses($$jqLite, element, event, options) {
  var classes = '';
  if (event) {
    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
  }
  if (options.addClass) {
    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
  }
  if (options.removeClass) {
    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
  }
  if (classes.length) {
    options.preparationClasses = classes;
    element.addClass(classes);
  }
}

function clearGeneratedClasses(element, options) {
  if (options.preparationClasses) {
    element.removeClass(options.preparationClasses);
    options.preparationClasses = null;
  }
  if (options.activeClasses) {
    element.removeClass(options.activeClasses);
    options.activeClasses = null;
  }
}

function blockKeyframeAnimations(node, applyBlock) {
  var value = applyBlock ? 'paused' : '';
  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
  applyInlineStyle(node, [key, value]);
  return [key, value];
}

function applyInlineStyle(node, styleTuple) {
  var prop = styleTuple[0];
  var value = styleTuple[1];
  node.style[prop] = value;
}

function concatWithSpace(a,b) {
  if (!a) return b;
  if (!b) return a;
  return a + ' ' + b;
}

var helpers = {
  blockTransitions: function(node, duration) {
    // we use a negative delay value since it performs blocking
    // yet it doesn't kill any existing transitions running on the
    // same element which makes this safe for class-based animations
    var value = duration ? '-' + duration + 's' : '';
    applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
    return [TRANSITION_DELAY_PROP, value];
  }
};

var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
  var queue, cancelFn;

  function scheduler(tasks) {
    // we make a copy since RAFScheduler mutates the state
    // of the passed in array variable and this would be difficult
    // to track down on the outside code
    queue = queue.concat(tasks);
    nextTick();
  }

  queue = scheduler.queue = [];

  /* waitUntilQuiet does two things:
   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
   *
   * The motivation here is that animation code can request more time from the scheduler
   * before the next wave runs. This allows for certain DOM properties such as classes to
   * be resolved in time for the next animation to run.
   */
  scheduler.waitUntilQuiet = function(fn) {
    if (cancelFn) cancelFn();

    cancelFn = $$rAF(function() {
      cancelFn = null;
      fn();
      nextTick();
    });
  };

  return scheduler;

  function nextTick() {
    if (!queue.length) return;

    var items = queue.shift();
    for (var i = 0; i < items.length; i++) {
      items[i]();
    }

    if (!cancelFn) {
      $$rAF(function() {
        if (!cancelFn) nextTick();
      });
    }
  }
}];

/**
 * @ngdoc directive
 * @name ngAnimateChildren
 * @restrict AE
 * @element ANY
 *
 * @description
 *
 * ngAnimateChildren allows you to specify that children of this element should animate even if any
 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
 * (structural) animation, child elements that also have an active structural animation are not animated.
 *
 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
 *
 *
 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
 *
 * @example
 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
     <file name="index.html">
       <div ng-controller="MainController as main">
         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
         <hr>
         <div ng-animate-children="{{main.animateChildren}}">
           <div ng-if="main.enterElement" class="container">
             List of items:
             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
           </div>
         </div>
       </div>
     </file>
     <file name="animations.css">

      .container.ng-enter,
      .container.ng-leave {
        transition: all ease 1.5s;
      }

      .container.ng-enter,
      .container.ng-leave-active {
        opacity: 0;
      }

      .container.ng-leave,
      .container.ng-enter-active {
        opacity: 1;
      }

      .item {
        background: firebrick;
        color: #FFF;
        margin-bottom: 10px;
      }

      .item.ng-enter,
      .item.ng-leave {
        transition: transform 1.5s ease;
      }

      .item.ng-enter {
        transform: translateX(50px);
      }

      .item.ng-enter-active {
        transform: translateX(0);
      }
    </file>
    <file name="script.js">
      angular.module('ngAnimateChildren', ['ngAnimate'])
        .controller('MainController', function MainController() {
          this.animateChildren = false;
          this.enterElement = false;
        });
    </file>
  </example>
 */
var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
  return {
    link: function(scope, element, attrs) {
      var val = attrs.ngAnimateChildren;
      if (isString(val) && val.length === 0) { //empty attribute
        element.data(NG_ANIMATE_CHILDREN_DATA, true);
      } else {
        // Interpolate and set the value, so that it is available to
        // animations that run right after compilation
        setData($interpolate(val)(scope));
        attrs.$observe('ngAnimateChildren', setData);
      }

      function setData(value) {
        value = value === 'on' || value === 'true';
        element.data(NG_ANIMATE_CHILDREN_DATA, value);
      }
    }
  };
}];

/* exported $AnimateCssProvider */

var ANIMATE_TIMER_KEY = '$$animateCss';

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 *
 * @description
 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
 * directives to create more complex animations that can be purely driven using CSS code.
 *
 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
 *
 * ## General Use
 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
 * any automatic control over cancelling animations and/or preventing animations from being run on
 * child elements will not be handled by AngularJS. For this to work as expected, please use `$animate` to
 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
 * the CSS animation.
 *
 * The example below shows how we can create a folding animation on an element using `ng-if`:
 *
 * ```html
 * <!-- notice the `fold-animation` CSS class -->
 * <div ng-if="onOff" class="fold-animation">
 *   This element will go BOOM
 * </div>
 * <button ng-click="onOff=true">Fold In</button>
 * ```
 *
 * Now we create the **JavaScript animation** that will trigger the CSS transition:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * ## More Advanced Uses
 *
 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
 *
 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
 * to provide a working animation that will run in CSS.
 *
 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         addClass: 'red large-text pulse-twice',
 *         easing: 'ease-out',
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
 *
 * ```css
 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
 * .red { background:red; }
 * .large-text { font-size:20px; }
 *
 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
 * .pulse-twice {
 *   animation: 0.5s pulse linear 2;
 *   -webkit-animation: 0.5s pulse linear 2;
 * }
 *
 * @keyframes pulse {
 *   from { transform: scale(0.5); }
 *   to { transform: scale(1.5); }
 * }
 *
 * @-webkit-keyframes pulse {
 *   from { -webkit-transform: scale(0.5); }
 *   to { -webkit-transform: scale(1.5); }
 * }
 * ```
 *
 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
 *
 * ## How the Options are handled
 *
 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
 * styles using the `from` and `to` properties.
 *
 * ```js
 * var animator = $animateCss(element, {
 *   from: { background:'red' },
 *   to: { background:'blue' }
 * });
 * animator.start();
 * ```
 *
 * ```css
 * .rotating-animation {
 *   animation:0.5s rotate linear;
 *   -webkit-animation:0.5s rotate linear;
 * }
 *
 * @keyframes rotate {
 *   from { transform: rotate(0deg); }
 *   to { transform: rotate(360deg); }
 * }
 *
 * @-webkit-keyframes rotate {
 *   from { -webkit-transform: rotate(0deg); }
 *   to { -webkit-transform: rotate(360deg); }
 * }
 * ```
 *
 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
 * and spread across the transition and keyframe animation.
 *
 * ## What is returned
 *
 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
 *
 * ```js
 * var animator = $animateCss(element, { ... });
 * ```
 *
 * Now what do the contents of our `animator` variable look like:
 *
 * ```js
 * {
 *   // starts the animation
 *   start: Function,
 *
 *   // ends (aborts) the animation
 *   end: Function
 * }
 * ```
 *
 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
 * and that changing them will not reconfigure the parameters of the animation.
 *
 * ### runner.done() vs runner.then()
 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
 * unless you really need a digest to kick off afterwards.
 *
 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
 *
 * @param {DOMElement} element the element that will be animated
 * @param {object} options the animation-related options that will be applied during the animation
 *
 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
 * is provided then the animation will be skipped entirely.
 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
 * CSS delay value.
 * * `stagger` - A numeric time value representing the delay between successively animated elements
 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
 *    the animation is closed. This is useful for when the styles are used purely for the sake of
 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
 *    By default this value is set to `false`.
 *
 * @return {object} an object with start and end methods and details about the animation.
 *
 * * `start` - The method to start the animation. This will return a `Promise` when called.
 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
 */
var ONE_SECOND = 1000;

var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
var CLOSING_TIME_BUFFER = 1.5;

var DETECT_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP,
  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
};

var DETECT_STAGGER_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP
};

function getCssKeyframeDurationStyle(duration) {
  return [ANIMATION_DURATION_PROP, duration + 's'];
}

function getCssDelayStyle(delay, isKeyframeAnimation) {
  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
  return [prop, delay + 's'];
}

function computeCssStyles($window, element, properties) {
  var styles = Object.create(null);
  var detectedStyles = $window.getComputedStyle(element) || {};
  forEach(properties, function(formalStyleName, actualStyleName) {
    var val = detectedStyles[formalStyleName];
    if (val) {
      var c = val.charAt(0);

      // only numerical-based values have a negative sign or digit as the first value
      if (c === '-' || c === '+' || c >= 0) {
        val = parseMaxTime(val);
      }

      // by setting this to null in the event that the delay is not set or is set directly as 0
      // then we can still allow for negative values to be used later on and not mistake this
      // value for being greater than any other negative value.
      if (val === 0) {
        val = null;
      }
      styles[actualStyleName] = val;
    }
  });

  return styles;
}

function parseMaxTime(str) {
  var maxValue = 0;
  var values = str.split(/\s*,\s*/);
  forEach(values, function(value) {
    // it's always safe to consider only second values and omit `ms` values since
    // getComputedStyle will always handle the conversion for us
    if (value.charAt(value.length - 1) === 's') {
      value = value.substring(0, value.length - 1);
    }
    value = parseFloat(value) || 0;
    maxValue = maxValue ? Math.max(value, maxValue) : value;
  });
  return maxValue;
}

function truthyTimingValue(val) {
  return val === 0 || val != null;
}

function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
  var style = TRANSITION_PROP;
  var value = duration + 's';
  if (applyOnlyDuration) {
    style += DURATION_KEY;
  } else {
    value += ' linear all';
  }
  return [style, value];
}

// we do not reassign an already present style value since
// if we detect the style property value again we may be
// detecting styles that were added via the `from` styles.
// We make use of `isDefined` here since an empty string
// or null value (which is what getPropertyValue will return
// for a non-existing style) will still be marked as a valid
// value for the style (a falsy value implies that the style
// is to be removed at the end of the animation). If we had a simple
// "OR" statement then it would not be enough to catch that.
function registerRestorableStyles(backup, node, properties) {
  forEach(properties, function(prop) {
    backup[prop] = isDefined(backup[prop])
        ? backup[prop]
        : node.style.getPropertyValue(prop);
  });
}

var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {

  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout', '$$animateCache',
               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,   $$animateCache,
                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function computeCachedCssStyles(node, className, cacheKey, allowNoDuration, properties) {
      var timings = $$animateCache.get(cacheKey);

      if (!timings) {
        timings = computeCssStyles($window, node, properties);
        if (timings.animationIterationCount === 'infinite') {
          timings.animationIterationCount = 1;
        }
      }

      // if a css animation has no duration we
      // should mark that so that repeated addClass/removeClass calls are skipped
      var hasDuration = allowNoDuration || (timings.transitionDuration > 0 || timings.animationDuration > 0);

      // we keep putting this in multiple times even though the value and the cacheKey are the same
      // because we're keeping an internal tally of how many duplicate animations are detected.
      $$animateCache.put(cacheKey, timings, hasDuration);

      return timings;
    }

    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
      var stagger;
      var staggerCacheKey = 'stagger-' + cacheKey;

      // if we have one or more existing matches of matching elements
      // containing the same parent + CSS styles (which is how cacheKey works)
      // then staggering is possible
      if ($$animateCache.count(cacheKey) > 0) {
        stagger = $$animateCache.get(staggerCacheKey);

        if (!stagger) {
          var staggerClassName = pendClasses(className, '-stagger');

          $$jqLite.addClass(node, staggerClassName);

          stagger = computeCssStyles($window, node, properties);

          // force the conversion of a null value to zero incase not set
          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);

          $$jqLite.removeClass(node, staggerClassName);

          $$animateCache.put(staggerCacheKey, stagger, true);
        }
      }

      return stagger || {};
    }

    var rafWaitQueue = [];
    function waitUntilQuiet(callback) {
      rafWaitQueue.push(callback);
      $$rAFScheduler.waitUntilQuiet(function() {
        $$animateCache.flush();

        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
        var pageWidth = $$forceReflow();

        // we use a for loop to ensure that if the queue is changed
        // during this looping then it will consider new requests
        for (var i = 0; i < rafWaitQueue.length; i++) {
          rafWaitQueue[i](pageWidth);
        }
        rafWaitQueue.length = 0;
      });
    }

    function computeTimings(node, className, cacheKey, allowNoDuration) {
      var timings = computeCachedCssStyles(node, className, cacheKey, allowNoDuration, DETECT_CSS_PROPERTIES);
      var aD = timings.animationDelay;
      var tD = timings.transitionDelay;
      timings.maxDelay = aD && tD
          ? Math.max(aD, tD)
          : (aD || tD);
      timings.maxDuration = Math.max(
          timings.animationDuration * timings.animationIterationCount,
          timings.transitionDuration);

      return timings;
    }

    return function init(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = prepareAnimationOptions(copy(options));
      }

      var restoreStyles = {};
      var node = getDomNode(element);
      if (!node
          || !node.parentNode
          || !$$animateQueue.enabled()) {
        return closeAndReturnNoopAnimator();
      }

      var temporaryStyles = [];
      var classes = element.attr('class');
      var styles = packageStyles(options);
      var animationClosed;
      var animationPaused;
      var animationCompleted;
      var runner;
      var runnerHost;
      var maxDelay;
      var maxDelayTime;
      var maxDuration;
      var maxDurationTime;
      var startTime;
      var events = [];

      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
        return closeAndReturnNoopAnimator();
      }

      var method = options.event && isArray(options.event)
            ? options.event.join(' ')
            : options.event;

      var isStructural = method && options.structural;
      var structuralClassName = '';
      var addRemoveClassName = '';

      if (isStructural) {
        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
      } else if (method) {
        structuralClassName = method;
      }

      if (options.addClass) {
        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
      }

      if (options.removeClass) {
        if (addRemoveClassName.length) {
          addRemoveClassName += ' ';
        }
        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
      }

      // there may be a situation where a structural animation is combined together
      // with CSS classes that need to resolve before the animation is computed.
      // However this means that there is no explicit CSS code to block the animation
      // from happening (by setting 0s none in the class name). If this is the case
      // we need to apply the classes before the first rAF so we know to continue if
      // there actually is a detected transition or keyframe animation
      if (options.applyClassesEarly && addRemoveClassName.length) {
        applyAnimationClasses(element, options);
      }

      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
      var fullClassName = classes + ' ' + preparationClasses;
      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;

      // there is no way we can trigger an animation if no styles and
      // no classes are being applied which would then trigger a transition,
      // unless there a is raw keyframe value that is applied to the element.
      if (!containsKeyframeAnimation
           && !hasToStyles
           && !preparationClasses) {
        return closeAndReturnNoopAnimator();
      }

      var stagger, cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
      if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
        preparationClasses = null;
        return closeAndReturnNoopAnimator();
      }

      if (options.stagger > 0) {
        var staggerVal = parseFloat(options.stagger);
        stagger = {
          transitionDelay: staggerVal,
          animationDelay: staggerVal,
          transitionDuration: 0,
          animationDuration: 0
        };
      } else {
        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
      }

      if (!options.$$skipPreparationClasses) {
        $$jqLite.addClass(element, preparationClasses);
      }

      var applyOnlyDuration;

      if (options.transitionStyle) {
        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
        applyInlineStyle(node, transitionStyle);
        temporaryStyles.push(transitionStyle);
      }

      if (options.duration >= 0) {
        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);

        // we set the duration so that it will be picked up by getComputedStyle later
        applyInlineStyle(node, durationStyle);
        temporaryStyles.push(durationStyle);
      }

      if (options.keyframeStyle) {
        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
        applyInlineStyle(node, keyframeStyle);
        temporaryStyles.push(keyframeStyle);
      }

      var itemIndex = stagger
          ? options.staggerIndex >= 0
              ? options.staggerIndex
              : $$animateCache.count(cacheKey)
          : 0;

      var isFirst = itemIndex === 0;

      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
      // without causing any combination of transitions to kick in. By adding a negative delay value
      // it forces the setup class' transition to end immediately. We later then remove the negative
      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
      // that if there is no transition defined then nothing will happen and this will also allow
      // other transitions to be stacked on top of each other without any chopping them out.
      if (isFirst && !options.skipBlocking) {
        helpers.blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
      }

      var timings = computeTimings(node, fullClassName, cacheKey, !isStructural);
      var relativeDelay = timings.maxDelay;
      maxDelay = Math.max(relativeDelay, 0);
      maxDuration = timings.maxDuration;

      var flags = {};
      flags.hasTransitions          = timings.transitionDuration > 0;
      flags.hasAnimations           = timings.animationDuration > 0;
      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
      flags.applyTransitionDuration = hasToStyles && (
                                        (flags.hasTransitions && !flags.hasTransitionAll)
                                         || (flags.hasAnimations && !flags.hasTransitions));
      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
      flags.recalculateTimingStyles = addRemoveClassName.length > 0;

      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;

        if (flags.applyTransitionDuration) {
          flags.hasTransitions = true;
          timings.transitionDuration = maxDuration;
          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
        }

        if (flags.applyAnimationDuration) {
          flags.hasAnimations = true;
          timings.animationDuration = maxDuration;
          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
        }
      }

      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
        return closeAndReturnNoopAnimator();
      }

      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);

      if (options.delay != null) {
        var delayStyle;
        if (typeof options.delay !== 'boolean') {
          delayStyle = parseFloat(options.delay);
          // number in options.delay means we have to recalculate the delay for the closing timeout
          maxDelay = Math.max(delayStyle, 0);
        }

        if (flags.applyTransitionDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle));
        }

        if (flags.applyAnimationDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
        }
      }

      // we need to recalculate the delay value since we used a pre-emptive negative
      // delay value and the delay value is required for the final event checking. This
      // property will ensure that this will happen after the RAF phase has passed.
      if (options.duration == null && timings.transitionDuration > 0) {
        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
      }

      maxDelayTime = maxDelay * ONE_SECOND;
      maxDurationTime = maxDuration * ONE_SECOND;
      if (!options.skipBlocking) {
        flags.blockTransition = timings.transitionDuration > 0;
        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
                                       stagger.animationDelay > 0 &&
                                       stagger.animationDuration === 0;
      }

      if (options.from) {
        if (options.cleanupStyles) {
          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
        }
        applyAnimationFromStyles(element, options);
      }

      if (flags.blockTransition || flags.blockKeyframeAnimation) {
        applyBlocking(maxDuration);
      } else if (!options.skipBlocking) {
        helpers.blockTransitions(node, false);
      }

      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
      return {
        $$willAnimate: true,
        end: endFn,
        start: function() {
          if (animationClosed) return;

          runnerHost = {
            end: endFn,
            cancel: cancelFn,
            resume: null, //this will be set during the start() phase
            pause: null
          };

          runner = new $$AnimateRunner(runnerHost);

          waitUntilQuiet(start);

          // we don't have access to pause/resume the animation
          // since it hasn't run yet. AnimateRunner will therefore
          // set noop functions for resume and pause and they will
          // later be overridden once the animation is triggered
          return runner;
        }
      };

      function endFn() {
        close();
      }

      function cancelFn() {
        close(true);
      }

      function close(rejected) {
        // if the promise has been called already then we shouldn't close
        // the animation again
        if (animationClosed || (animationCompleted && animationPaused)) return;
        animationClosed = true;
        animationPaused = false;

        if (preparationClasses && !options.$$skipPreparationClasses) {
          $$jqLite.removeClass(element, preparationClasses);
        }

        if (activeClasses) {
          $$jqLite.removeClass(element, activeClasses);
        }

        blockKeyframeAnimations(node, false);
        helpers.blockTransitions(node, false);

        forEach(temporaryStyles, function(entry) {
          // There is only one way to remove inline style properties entirely from elements.
          // By using `removeProperty` this works, but we need to convert camel-cased CSS
          // styles down to hyphenated values.
          node.style[entry[0]] = '';
        });

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);

        if (Object.keys(restoreStyles).length) {
          forEach(restoreStyles, function(value, prop) {
            if (value) {
              node.style.setProperty(prop, value);
            } else {
              node.style.removeProperty(prop);
            }
          });
        }

        // the reason why we have this option is to allow a synchronous closing callback
        // that is fired as SOON as the animation ends (when the CSS is removed) or if
        // the animation never takes off at all. A good example is a leave animation since
        // the element must be removed just after the animation is over or else the element
        // will appear on screen for one animation frame causing an overbearing flicker.
        if (options.onDone) {
          options.onDone();
        }

        if (events && events.length) {
          // Remove the transitionend / animationend listener(s)
          element.off(events.join(' '), onAnimationProgress);
        }

        //Cancel the fallback closing timeout and remove the timer data
        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
        if (animationTimerData) {
          $timeout.cancel(animationTimerData[0].timer);
          element.removeData(ANIMATE_TIMER_KEY);
        }

        // if the preparation function fails then the promise is not setup
        if (runner) {
          runner.complete(!rejected);
        }
      }

      function applyBlocking(duration) {
        if (flags.blockTransition) {
          helpers.blockTransitions(node, duration);
        }

        if (flags.blockKeyframeAnimation) {
          blockKeyframeAnimations(node, !!duration);
        }
      }

      function closeAndReturnNoopAnimator() {
        runner = new $$AnimateRunner({
          end: endFn,
          cancel: cancelFn
        });

        // should flush the cache animation
        waitUntilQuiet(noop);
        close();

        return {
          $$willAnimate: false,
          start: function() {
            return runner;
          },
          end: endFn
        };
      }

      function onAnimationProgress(event) {
        event.stopPropagation();
        var ev = event.originalEvent || event;

        if (ev.target !== node) {
          // Since TransitionEvent / AnimationEvent bubble up,
          // we have to ignore events by finished child animations
          return;
        }

        // we now always use `Date.now()` due to the recent changes with
        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
        var timeStamp = ev.$manualTimeStamp || Date.now();

        /* Firefox (or possibly just Gecko) likes to not round values up
         * when a ms measurement is used for the animation */
        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));

        /* $manualTimeStamp is a mocked timeStamp value which is set
         * within browserTrigger(). This is only here so that tests can
         * mock animations properly. Real events fallback to event.timeStamp,
         * or, if they don't, then a timeStamp is automatically created for them.
         * We're checking to see if the timeStamp surpasses the expected delay,
         * but we're using elapsedTime instead of the timeStamp on the 2nd
         * pre-condition since animationPauseds sometimes close off early */
        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
          // we set this flag to ensure that if the transition is paused then, when resumed,
          // the animation will automatically close itself since transitions cannot be paused.
          animationCompleted = true;
          close();
        }
      }

      function start() {
        if (animationClosed) return;
        if (!node.parentNode) {
          close();
          return;
        }

        // even though we only pause keyframe animations here the pause flag
        // will still happen when transitions are used. Only the transition will
        // not be paused since that is not possible. If the animation ends when
        // paused then it will not complete until unpaused or cancelled.
        var playPause = function(playAnimation) {
          if (!animationCompleted) {
            animationPaused = !playAnimation;
            if (timings.animationDuration) {
              var value = blockKeyframeAnimations(node, animationPaused);
              if (animationPaused) {
                temporaryStyles.push(value);
              } else {
                removeFromArray(temporaryStyles, value);
              }
            }
          } else if (animationPaused && playAnimation) {
            animationPaused = false;
            close();
          }
        };

        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
        // being inherited from the parent. If the transition duration is zero then we can safely
        // rely that the delay value is an intentional stagger delay style.
        var maxStagger = itemIndex > 0
                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
                            (timings.animationDuration && stagger.animationDuration === 0))
                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
        if (maxStagger) {
          $timeout(triggerAnimationStart,
                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
                   false);
        } else {
          triggerAnimationStart();
        }

        // this will decorate the existing promise runner with pause/resume methods
        runnerHost.resume = function() {
          playPause(true);
        };

        runnerHost.pause = function() {
          playPause(false);
        };

        function triggerAnimationStart() {
          // just incase a stagger animation kicks in when the animation
          // itself was cancelled entirely
          if (animationClosed) return;

          applyBlocking(false);

          forEach(temporaryStyles, function(entry) {
            var key = entry[0];
            var value = entry[1];
            node.style[key] = value;
          });

          applyAnimationClasses(element, options);
          $$jqLite.addClass(element, activeClasses);

          if (flags.recalculateTimingStyles) {
            fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
            cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);

            timings = computeTimings(node, fullClassName, cacheKey, false);
            relativeDelay = timings.maxDelay;
            maxDelay = Math.max(relativeDelay, 0);
            maxDuration = timings.maxDuration;

            if (maxDuration === 0) {
              close();
              return;
            }

            flags.hasTransitions = timings.transitionDuration > 0;
            flags.hasAnimations = timings.animationDuration > 0;
          }

          if (flags.applyAnimationDelay) {
            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
                  ? parseFloat(options.delay)
                  : relativeDelay;

            maxDelay = Math.max(relativeDelay, 0);
            timings.animationDelay = relativeDelay;
            delayStyle = getCssDelayStyle(relativeDelay, true);
            temporaryStyles.push(delayStyle);
            node.style[delayStyle[0]] = delayStyle[1];
          }

          maxDelayTime = maxDelay * ONE_SECOND;
          maxDurationTime = maxDuration * ONE_SECOND;

          if (options.easing) {
            var easeProp, easeVal = options.easing;
            if (flags.hasTransitions) {
              easeProp = TRANSITION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
            if (flags.hasAnimations) {
              easeProp = ANIMATION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
          }

          if (timings.transitionDuration) {
            events.push(TRANSITIONEND_EVENT);
          }

          if (timings.animationDuration) {
            events.push(ANIMATIONEND_EVENT);
          }

          startTime = Date.now();
          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
          var endTime = startTime + timerTime;

          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
          var setupFallbackTimer = true;
          if (animationsData.length) {
            var currentTimerData = animationsData[0];
            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
            if (setupFallbackTimer) {
              $timeout.cancel(currentTimerData.timer);
            } else {
              animationsData.push(close);
            }
          }

          if (setupFallbackTimer) {
            var timer = $timeout(onAnimationExpired, timerTime, false);
            animationsData[0] = {
              timer: timer,
              expectedEndTime: endTime
            };
            animationsData.push(close);
            element.data(ANIMATE_TIMER_KEY, animationsData);
          }

          if (events.length) {
            element.on(events.join(' '), onAnimationProgress);
          }

          if (options.to) {
            if (options.cleanupStyles) {
              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
            }
            applyAnimationToStyles(element, options);
          }
        }

        function onAnimationExpired() {
          var animationsData = element.data(ANIMATE_TIMER_KEY);

          // this will be false in the event that the element was
          // removed from the DOM (via a leave animation or something
          // similar)
          if (animationsData) {
            for (var i = 1; i < animationsData.length; i++) {
              animationsData[i]();
            }
            element.removeData(ANIMATE_TIMER_KEY);
          }
        }
      }
    };
  }];
}];

var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateCssDriver');

  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';

  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';

  function isDocumentFragment(node) {
    return node.parentNode && node.parentNode.nodeType === 11;
  }

  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {

    // only browsers that support these properties can render animations
    if (!$sniffer.animations && !$sniffer.transitions) return noop;

    var bodyNode = $document[0].body;
    var rootNode = getDomNode($rootElement);

    var rootBodyElement = jqLite(
      // this is to avoid using something that exists outside of the body
      // we also special case the doc fragment case because our unit test code
      // appends the $rootElement to the body after the app has been bootstrapped
      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
    );

    return function initDriverFn(animationDetails) {
      return animationDetails.from && animationDetails.to
          ? prepareFromToAnchorAnimation(animationDetails.from,
                                         animationDetails.to,
                                         animationDetails.classes,
                                         animationDetails.anchors)
          : prepareRegularAnimation(animationDetails);
    };

    function filterCssClasses(classes) {
      //remove all the `ng-` stuff
      return classes.replace(/\bng-\S+\b/g, '');
    }

    function getUniqueValues(a, b) {
      if (isString(a)) a = a.split(' ');
      if (isString(b)) b = b.split(' ');
      return a.filter(function(val) {
        return b.indexOf(val) === -1;
      }).join(' ');
    }

    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
      var startingClasses = filterCssClasses(getClassVal(clone));

      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);

      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);

      rootBodyElement.append(clone);

      var animatorIn, animatorOut = prepareOutAnimation();

      // the user may not end up using the `out` animation and
      // only making use of the `in` animation or vice-versa.
      // In either case we should allow this and not assume the
      // animation is over unless both animations are not used.
      if (!animatorOut) {
        animatorIn = prepareInAnimation();
        if (!animatorIn) {
          return end();
        }
      }

      var startingAnimator = animatorOut || animatorIn;

      return {
        start: function() {
          var runner;

          var currentAnimation = startingAnimator.start();
          currentAnimation.done(function() {
            currentAnimation = null;
            if (!animatorIn) {
              animatorIn = prepareInAnimation();
              if (animatorIn) {
                currentAnimation = animatorIn.start();
                currentAnimation.done(function() {
                  currentAnimation = null;
                  end();
                  runner.complete();
                });
                return currentAnimation;
              }
            }
            // in the event that there is no `in` animation
            end();
            runner.complete();
          });

          runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn
          });

          return runner;

          function endFn() {
            if (currentAnimation) {
              currentAnimation.end();
            }
          }
        }
      };

      function calculateAnchorStyles(anchor) {
        var styles = {};

        var coords = getDomNode(anchor).getBoundingClientRect();

        // we iterate directly since safari messes up and doesn't return
        // all the keys for the coords object when iterated
        forEach(['width','height','top','left'], function(key) {
          var value = coords[key];
          switch (key) {
            case 'top':
              value += bodyNode.scrollTop;
              break;
            case 'left':
              value += bodyNode.scrollLeft;
              break;
          }
          styles[key] = Math.floor(value) + 'px';
        });
        return styles;
      }

      function prepareOutAnimation() {
        var animator = $animateCss(clone, {
          addClass: NG_OUT_ANCHOR_CLASS_NAME,
          delay: true,
          from: calculateAnchorStyles(outAnchor)
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function getClassVal(element) {
        return element.attr('class') || '';
      }

      function prepareInAnimation() {
        var endingClasses = filterCssClasses(getClassVal(inAnchor));
        var toAdd = getUniqueValues(endingClasses, startingClasses);
        var toRemove = getUniqueValues(startingClasses, endingClasses);

        var animator = $animateCss(clone, {
          to: calculateAnchorStyles(inAnchor),
          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
          delay: true
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function end() {
        clone.remove();
        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
      }
    }

    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
      var fromAnimation = prepareRegularAnimation(from, noop);
      var toAnimation = prepareRegularAnimation(to, noop);

      var anchorAnimations = [];
      forEach(anchors, function(anchor) {
        var outElement = anchor['out'];
        var inElement = anchor['in'];
        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
        if (animator) {
          anchorAnimations.push(animator);
        }
      });

      // no point in doing anything when there are no elements to animate
      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;

      return {
        start: function() {
          var animationRunners = [];

          if (fromAnimation) {
            animationRunners.push(fromAnimation.start());
          }

          if (toAnimation) {
            animationRunners.push(toAnimation.start());
          }

          forEach(anchorAnimations, function(animation) {
            animationRunners.push(animation.start());
          });

          var runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
          });

          $$AnimateRunner.all(animationRunners, function(status) {
            runner.complete(status);
          });

          return runner;

          function endFn() {
            forEach(animationRunners, function(runner) {
              runner.end();
            });
          }
        }
      };
    }

    function prepareRegularAnimation(animationDetails) {
      var element = animationDetails.element;
      var options = animationDetails.options || {};

      if (animationDetails.structural) {
        options.event = animationDetails.event;
        options.structural = true;
        options.applyClassesEarly = true;

        // we special case the leave animation since we want to ensure that
        // the element is removed as soon as the animation is over. Otherwise
        // a flicker might appear or the element may not be removed at all
        if (animationDetails.event === 'leave') {
          options.onDone = options.domOperation;
        }
      }

      // We assign the preparationClasses as the actual animation event since
      // the internals of $animateCss will just suffix the event token values
      // with `-active` to trigger the animation.
      if (options.preparationClasses) {
        options.event = concatWithSpace(options.event, options.preparationClasses);
      }

      var animator = $animateCss(element, options);

      // the driver lookup code inside of $$animation attempts to spawn a
      // driver one by one until a driver returns a.$$willAnimate animator object.
      // $animateCss will always return an object, however, it will pass in
      // a flag as a hint as to whether an animation was detected or not
      return animator.$$willAnimate ? animator : null;
    }
  }];
}];

// TODO(matsko): use caching here to speed things up for detection
// TODO(matsko): add documentation
//  by the time...

var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
       function($injector,   $$AnimateRunner,   $$jqLite) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
         // $animateJs(element, 'enter');
    return function(element, event, classes, options) {
      var animationClosed = false;

      // the `classes` argument is optional and if it is not used
      // then the classes will be resolved from the element's className
      // property as well as options.addClass/options.removeClass.
      if (arguments.length === 3 && isObject(classes)) {
        options = classes;
        classes = null;
      }

      options = prepareAnimationOptions(options);
      if (!classes) {
        classes = element.attr('class') || '';
        if (options.addClass) {
          classes += ' ' + options.addClass;
        }
        if (options.removeClass) {
          classes += ' ' + options.removeClass;
        }
      }

      var classesToAdd = options.addClass;
      var classesToRemove = options.removeClass;

      // the lookupAnimations function returns a series of animation objects that are
      // matched up with one or more of the CSS classes. These animation objects are
      // defined via the module.animation factory function. If nothing is detected then
      // we don't return anything which then makes $animation query the next driver.
      var animations = lookupAnimations(classes);
      var before, after;
      if (animations.length) {
        var afterFn, beforeFn;
        if (event === 'leave') {
          beforeFn = 'leave';
          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
        } else {
          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
          afterFn = event;
        }

        if (event !== 'enter' && event !== 'move') {
          before = packageAnimations(element, event, options, animations, beforeFn);
        }
        after  = packageAnimations(element, event, options, animations, afterFn);
      }

      // no matching animations
      if (!before && !after) return;

      function applyOptions() {
        options.domOperation();
        applyAnimationClasses(element, options);
      }

      function close() {
        animationClosed = true;
        applyOptions();
        applyAnimationStyles(element, options);
      }

      var runner;

      return {
        $$willAnimate: true,
        end: function() {
          if (runner) {
            runner.end();
          } else {
            close();
            runner = new $$AnimateRunner();
            runner.complete(true);
          }
          return runner;
        },
        start: function() {
          if (runner) {
            return runner;
          }

          runner = new $$AnimateRunner();
          var closeActiveAnimations;
          var chain = [];

          if (before) {
            chain.push(function(fn) {
              closeActiveAnimations = before(fn);
            });
          }

          if (chain.length) {
            chain.push(function(fn) {
              applyOptions();
              fn(true);
            });
          } else {
            applyOptions();
          }

          if (after) {
            chain.push(function(fn) {
              closeActiveAnimations = after(fn);
            });
          }

          runner.setHost({
            end: function() {
              endAnimations();
            },
            cancel: function() {
              endAnimations(true);
            }
          });

          $$AnimateRunner.chain(chain, onComplete);
          return runner;

          function onComplete(success) {
            close(success);
            runner.complete(success);
          }

          function endAnimations(cancelled) {
            if (!animationClosed) {
              (closeActiveAnimations || noop)(cancelled);
              onComplete(cancelled);
            }
          }
        }
      };

      function executeAnimationFn(fn, element, event, options, onDone) {
        var args;
        switch (event) {
          case 'animate':
            args = [element, options.from, options.to, onDone];
            break;

          case 'setClass':
            args = [element, classesToAdd, classesToRemove, onDone];
            break;

          case 'addClass':
            args = [element, classesToAdd, onDone];
            break;

          case 'removeClass':
            args = [element, classesToRemove, onDone];
            break;

          default:
            args = [element, onDone];
            break;
        }

        args.push(options);

        var value = fn.apply(fn, args);
        if (value) {
          if (isFunction(value.start)) {
            value = value.start();
          }

          if (value instanceof $$AnimateRunner) {
            value.done(onDone);
          } else if (isFunction(value)) {
            // optional onEnd / onCancel callback
            return value;
          }
        }

        return noop;
      }

      function groupEventedAnimations(element, event, options, animations, fnName) {
        var operations = [];
        forEach(animations, function(ani) {
          var animation = ani[fnName];
          if (!animation) return;

          // note that all of these animations will run in parallel
          operations.push(function() {
            var runner;
            var endProgressCb;

            var resolved = false;
            var onAnimationComplete = function(rejected) {
              if (!resolved) {
                resolved = true;
                (endProgressCb || noop)(rejected);
                runner.complete(!rejected);
              }
            };

            runner = new $$AnimateRunner({
              end: function() {
                onAnimationComplete();
              },
              cancel: function() {
                onAnimationComplete(true);
              }
            });

            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
              var cancelled = result === false;
              onAnimationComplete(cancelled);
            });

            return runner;
          });
        });

        return operations;
      }

      function packageAnimations(element, event, options, animations, fnName) {
        var operations = groupEventedAnimations(element, event, options, animations, fnName);
        if (operations.length === 0) {
          var a, b;
          if (fnName === 'beforeSetClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
          } else if (fnName === 'setClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
          }

          if (a) {
            operations = operations.concat(a);
          }
          if (b) {
            operations = operations.concat(b);
          }
        }

        if (operations.length === 0) return;

        // TODO(matsko): add documentation
        return function startAnimation(callback) {
          var runners = [];
          if (operations.length) {
            forEach(operations, function(animateFn) {
              runners.push(animateFn());
            });
          }

          if (runners.length) {
            $$AnimateRunner.all(runners, callback);
          }  else {
            callback();
          }

          return function endFn(reject) {
            forEach(runners, function(runner) {
              if (reject) {
                runner.cancel();
              } else {
                runner.end();
              }
            });
          };
        };
      }
    };

    function lookupAnimations(classes) {
      classes = isArray(classes) ? classes : classes.split(' ');
      var matches = [], flagMap = {};
      for (var i = 0; i < classes.length; i++) {
        var klass = classes[i],
            animationFactory = $animateProvider.$$registeredAnimations[klass];
        if (animationFactory && !flagMap[klass]) {
          matches.push($injector.get(animationFactory));
          flagMap[klass] = true;
        }
      }
      return matches;
    }
  }];
}];

var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateJsDriver');
  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
    return function initDriverFn(animationDetails) {
      if (animationDetails.from && animationDetails.to) {
        var fromAnimation = prepareAnimation(animationDetails.from);
        var toAnimation = prepareAnimation(animationDetails.to);
        if (!fromAnimation && !toAnimation) return;

        return {
          start: function() {
            var animationRunners = [];

            if (fromAnimation) {
              animationRunners.push(fromAnimation.start());
            }

            if (toAnimation) {
              animationRunners.push(toAnimation.start());
            }

            $$AnimateRunner.all(animationRunners, done);

            var runner = new $$AnimateRunner({
              end: endFnFactory(),
              cancel: endFnFactory()
            });

            return runner;

            function endFnFactory() {
              return function() {
                forEach(animationRunners, function(runner) {
                  // at this point we cannot cancel animations for groups just yet. 1.5+
                  runner.end();
                });
              };
            }

            function done(status) {
              runner.complete(status);
            }
          }
        };
      } else {
        return prepareAnimation(animationDetails);
      }
    };

    function prepareAnimation(animationDetails) {
      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
      var element = animationDetails.element;
      var event = animationDetails.event;
      var options = animationDetails.options;
      var classes = animationDetails.classes;
      return $$animateJs(element, event, classes, options);
    }
  }];
}];

var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var PRE_DIGEST_STATE = 1;
  var RUNNING_STATE = 2;
  var ONE_SPACE = ' ';

  var rules = this.rules = {
    skip: [],
    cancel: [],
    join: []
  };

  function getEventData(options) {
    return {
      addClass: options.addClass,
      removeClass: options.removeClass,
      from: options.from,
      to: options.to
    };
  }

  function makeTruthyCssClassMap(classString) {
    if (!classString) {
      return null;
    }

    var keys = classString.split(ONE_SPACE);
    var map = Object.create(null);

    forEach(keys, function(key) {
      map[key] = true;
    });
    return map;
  }

  function hasMatchingClasses(newClassString, currentClassString) {
    if (newClassString && currentClassString) {
      var currentClassMap = makeTruthyCssClassMap(currentClassString);
      return newClassString.split(ONE_SPACE).some(function(className) {
        return currentClassMap[className];
      });
    }
  }

  function isAllowed(ruleType, currentAnimation, previousAnimation) {
    return rules[ruleType].some(function(fn) {
      return fn(currentAnimation, previousAnimation);
    });
  }

  function hasAnimationClasses(animation, and) {
    var a = (animation.addClass || '').length > 0;
    var b = (animation.removeClass || '').length > 0;
    return and ? a && b : a || b;
  }

  rules.join.push(function(newAnimation, currentAnimation) {
    // if the new animation is class-based then we can just tack that on
    return !newAnimation.structural && hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // there is no need to animate anything if no classes are being added and
    // there is no structural animation that will be triggered
    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // why should we trigger a new structural animation if the element will
    // be removed from the DOM anyway?
    return currentAnimation.event === 'leave' && newAnimation.structural;
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // if there is an ongoing current animation then don't even bother running the class-based animation
    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // there can never be two structural animations running at the same time
    return currentAnimation.structural && newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // if the previous animation is already running, but the new animation will
    // be triggered, but the new animation is structural
    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // cancel the animation if classes added / removed in both animation cancel each other out,
    // but only if the current animation isn't structural

    if (currentAnimation.structural) return false;

    var nA = newAnimation.addClass;
    var nR = newAnimation.removeClass;
    var cA = currentAnimation.addClass;
    var cR = currentAnimation.removeClass;

    // early detection to save the global CPU shortage :)
    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
      return false;
    }

    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
  });

  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$Map',
               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
               '$$isDocumentHidden',
       function($$rAF,   $rootScope,   $rootElement,   $document,   $$Map,
                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow,
                $$isDocumentHidden) {

    var activeAnimationsLookup = new $$Map();
    var disabledElementsLookup = new $$Map();
    var animationsEnabled = null;

    function removeFromDisabledElementsLookup(evt) {
      disabledElementsLookup.delete(evt.target);
    }

    function postDigestTaskFactory() {
      var postDigestCalled = false;
      return function(fn) {
        // we only issue a call to postDigest before
        // it has first passed. This prevents any callbacks
        // from not firing once the animation has completed
        // since it will be out of the digest cycle.
        if (postDigestCalled) {
          fn();
        } else {
          $rootScope.$$postDigest(function() {
            postDigestCalled = true;
            fn();
          });
        }
      };
    }

    // Wait until all directive and route-related templates are downloaded and
    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
    // all of the remote templates being currently downloaded. If there are no
    // templates currently downloading then the watcher will still fire anyway.
    var deregisterWatch = $rootScope.$watch(
      function() { return $templateRequest.totalPendingRequests === 0; },
      function(isEmpty) {
        if (!isEmpty) return;
        deregisterWatch();

        // Now that all templates have been downloaded, $animate will wait until
        // the post digest queue is empty before enabling animations. By having two
        // calls to $postDigest calls we can ensure that the flag is enabled at the
        // very end of the post digest queue. Since all of the animations in $animate
        // use $postDigest, it's important that the code below executes at the end.
        // This basically means that the page is fully downloaded and compiled before
        // any animations are triggered.
        $rootScope.$$postDigest(function() {
          $rootScope.$$postDigest(function() {
            // we check for null directly in the event that the application already called
            // .enabled() with whatever arguments that it provided it with
            if (animationsEnabled === null) {
              animationsEnabled = true;
            }
          });
        });
      }
    );

    var callbackRegistry = Object.create(null);

    // remember that the `customFilter`/`classNameFilter` are set during the
    // provider/config stage therefore we can optimize here and setup helper functions
    var customFilter = $animateProvider.customFilter();
    var classNameFilter = $animateProvider.classNameFilter();
    var returnTrue = function() { return true; };

    var isAnimatableByFilter = customFilter || returnTrue;
    var isAnimatableClassName = !classNameFilter ? returnTrue : function(node, options) {
      var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
      return classNameFilter.test(className);
    };

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function normalizeAnimationDetails(element, animation) {
      return mergeAnimationDetails(element, animation, {});
    }

    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
      // eslint-disable-next-line no-bitwise
      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
    };

    function findCallbacks(targetParentNode, targetNode, event) {
      var matches = [];
      var entries = callbackRegistry[event];
      if (entries) {
        forEach(entries, function(entry) {
          if (contains.call(entry.node, targetNode)) {
            matches.push(entry.callback);
          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
            matches.push(entry.callback);
          }
        });
      }

      return matches;
    }

    function filterFromRegistry(list, matchContainer, matchCallback) {
      var containerNode = extractElementNode(matchContainer);
      return list.filter(function(entry) {
        var isMatch = entry.node === containerNode &&
                        (!matchCallback || entry.callback === matchCallback);
        return !isMatch;
      });
    }

    function cleanupEventListeners(phase, node) {
      if (phase === 'close' && !node.parentNode) {
        // If the element is not attached to a parentNode, it has been removed by
        // the domOperation, and we can safely remove the event callbacks
        $animate.off(node);
      }
    }

    var $animate = {
      on: function(event, container, callback) {
        var node = extractElementNode(container);
        callbackRegistry[event] = callbackRegistry[event] || [];
        callbackRegistry[event].push({
          node: node,
          callback: callback
        });

        // Remove the callback when the element is removed from the DOM
        jqLite(container).on('$destroy', function() {
          var animationDetails = activeAnimationsLookup.get(node);

          if (!animationDetails) {
            // If there's an animation ongoing, the callback calling code will remove
            // the event listeners. If we'd remove here, the callbacks would be removed
            // before the animation ends
            $animate.off(event, container, callback);
          }
        });
      },

      off: function(event, container, callback) {
        if (arguments.length === 1 && !isString(arguments[0])) {
          container = arguments[0];
          for (var eventType in callbackRegistry) {
            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
          }

          return;
        }

        var entries = callbackRegistry[event];
        if (!entries) return;

        callbackRegistry[event] = arguments.length === 1
            ? null
            : filterFromRegistry(entries, container, callback);
      },

      pin: function(element, parentElement) {
        assertArg(isElement(element), 'element', 'not an element');
        assertArg(isElement(parentElement), 'parentElement', 'not an element');
        element.data(NG_ANIMATE_PIN_DATA, parentElement);
      },

      push: function(element, event, options, domOperation) {
        options = options || {};
        options.domOperation = domOperation;
        return queueAnimation(element, event, options);
      },

      // this method has four signatures:
      //  () - global getter
      //  (bool) - global setter
      //  (element) - element getter
      //  (element, bool) - element setter<F37>
      enabled: function(element, bool) {
        var argCount = arguments.length;

        if (argCount === 0) {
          // () - Global getter
          bool = !!animationsEnabled;
        } else {
          var hasElement = isElement(element);

          if (!hasElement) {
            // (bool) - Global setter
            bool = animationsEnabled = !!element;
          } else {
            var node = getDomNode(element);

            if (argCount === 1) {
              // (element) - Element getter
              bool = !disabledElementsLookup.get(node);
            } else {
              // (element, bool) - Element setter
              if (!disabledElementsLookup.has(node)) {
                // The element is added to the map for the first time.
                // Create a listener to remove it on `$destroy` (to avoid memory leak).
                jqLite(element).on('$destroy', removeFromDisabledElementsLookup);
              }
              disabledElementsLookup.set(node, !bool);
            }
          }
        }

        return bool;
      }
    };

    return $animate;

    function queueAnimation(originalElement, event, initialOptions) {
      // we always make a copy of the options since
      // there should never be any side effects on
      // the input data when running `$animateCss`.
      var options = copy(initialOptions);

      var element = stripCommentsFromElement(originalElement);
      var node = getDomNode(element);
      var parentNode = node && node.parentNode;

      options = prepareAnimationOptions(options);

      // we create a fake runner with a working promise.
      // These methods will become available after the digest has passed
      var runner = new $$AnimateRunner();

      // this is used to trigger callbacks in postDigest mode
      var runInNextPostDigestOrNow = postDigestTaskFactory();

      if (isArray(options.addClass)) {
        options.addClass = options.addClass.join(' ');
      }

      if (options.addClass && !isString(options.addClass)) {
        options.addClass = null;
      }

      if (isArray(options.removeClass)) {
        options.removeClass = options.removeClass.join(' ');
      }

      if (options.removeClass && !isString(options.removeClass)) {
        options.removeClass = null;
      }

      if (options.from && !isObject(options.from)) {
        options.from = null;
      }

      if (options.to && !isObject(options.to)) {
        options.to = null;
      }

      // If animations are hard-disabled for the whole application there is no need to continue.
      // There are also situations where a directive issues an animation for a jqLite wrapper that
      // contains only comment nodes. In this case, there is no way we can perform an animation.
      if (!animationsEnabled ||
          !node ||
          !isAnimatableByFilter(node, event, initialOptions) ||
          !isAnimatableClassName(node, options)) {
        close();
        return runner;
      }

      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      var documentHidden = $$isDocumentHidden();

      // This is a hard disable of all animations the element itself, therefore  there is no need to
      // continue further past this point if not enabled
      // Animations are also disabled if the document is currently hidden (page is not visible
      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
      var skipAnimations = documentHidden || disabledElementsLookup.get(node);
      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
      var hasExistingAnimation = !!existingAnimation.state;

      // there is no point in traversing the same collection of parent ancestors if a followup
      // animation will be run on the same element that already did all that checking work
      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
        skipAnimations = !areAnimationsAllowed(node, parentNode, event);
      }

      if (skipAnimations) {
        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
        if (documentHidden) notifyProgress(runner, event, 'start', getEventData(options));
        close();
        if (documentHidden) notifyProgress(runner, event, 'close', getEventData(options));
        return runner;
      }

      if (isStructural) {
        closeChildAnimations(node);
      }

      var newAnimation = {
        structural: isStructural,
        element: element,
        event: event,
        addClass: options.addClass,
        removeClass: options.removeClass,
        close: close,
        options: options,
        runner: runner
      };

      if (hasExistingAnimation) {
        var skipAnimationFlag = isAllowed('skip', newAnimation, existingAnimation);
        if (skipAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            close();
            return runner;
          } else {
            mergeAnimationDetails(element, existingAnimation, newAnimation);
            return existingAnimation.runner;
          }
        }
        var cancelAnimationFlag = isAllowed('cancel', newAnimation, existingAnimation);
        if (cancelAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            // this will end the animation right away and it is safe
            // to do so since the animation is already running and the
            // runner callback code will run in async
            existingAnimation.runner.end();
          } else if (existingAnimation.structural) {
            // this means that the animation is queued into a digest, but
            // hasn't started yet. Therefore it is safe to run the close
            // method which will call the runner methods in async.
            existingAnimation.close();
          } else {
            // this will merge the new animation options into existing animation options
            mergeAnimationDetails(element, existingAnimation, newAnimation);

            return existingAnimation.runner;
          }
        } else {
          // a joined animation means that this animation will take over the existing one
          // so an example would involve a leave animation taking over an enter. Then when
          // the postDigest kicks in the enter will be ignored.
          var joinAnimationFlag = isAllowed('join', newAnimation, existingAnimation);
          if (joinAnimationFlag) {
            if (existingAnimation.state === RUNNING_STATE) {
              normalizeAnimationDetails(element, newAnimation);
            } else {
              applyGeneratedPreparationClasses($$jqLite, element, isStructural ? event : null, options);

              event = newAnimation.event = existingAnimation.event;
              options = mergeAnimationDetails(element, existingAnimation, newAnimation);

              //we return the same runner since only the option values of this animation will
              //be fed into the `existingAnimation`.
              return existingAnimation.runner;
            }
          }
        }
      } else {
        // normalization in this case means that it removes redundant CSS classes that
        // already exist (addClass) or do not exist (removeClass) on the element
        normalizeAnimationDetails(element, newAnimation);
      }

      // when the options are merged and cleaned up we may end up not having to do
      // an animation at all, therefore we should check this before issuing a post
      // digest callback. Structural animations will always run no matter what.
      var isValidAnimation = newAnimation.structural;
      if (!isValidAnimation) {
        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
                            || hasAnimationClasses(newAnimation);
      }

      if (!isValidAnimation) {
        close();
        clearElementAnimationState(node);
        return runner;
      }

      // the counter keeps track of cancelled animations
      var counter = (existingAnimation.counter || 0) + 1;
      newAnimation.counter = counter;

      markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);

      $rootScope.$$postDigest(function() {
        // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
        // happen if the animated element is a transcluded clone and also has a `templateUrl`
        // directive on it. Therefore, we must recreate `element` in order to interact with the
        // actual DOM nodes.
        // Note: We still need to use the old `node` for certain things, such as looking up in
        //       HashMaps where it was used as the key.

        element = stripCommentsFromElement(originalElement);

        var animationDetails = activeAnimationsLookup.get(node);
        var animationCancelled = !animationDetails;
        animationDetails = animationDetails || {};

        // if addClass/removeClass is called before something like enter then the
        // registered parent element may not be present. The code below will ensure
        // that a final value for parent element is obtained
        var parentElement = element.parent() || [];

        // animate/structural/class-based animations all have requirements. Otherwise there
        // is no point in performing an animation. The parent node must also be set.
        var isValidAnimation = parentElement.length > 0
                                && (animationDetails.event === 'animate'
                                    || animationDetails.structural
                                    || hasAnimationClasses(animationDetails));

        // this means that the previous animation was cancelled
        // even if the follow-up animation is the same event
        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
          // if another animation did not take over then we need
          // to make sure that the domOperation and options are
          // handled accordingly
          if (animationCancelled) {
            applyAnimationClasses(element, options);
            applyAnimationStyles(element, options);
          }

          // if the event changed from something like enter to leave then we do
          // it, otherwise if it's the same then the end result will be the same too
          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
            options.domOperation();
            runner.end();
          }

          // in the event that the element animation was not cancelled or a follow-up animation
          // isn't allowed to animate from here then we need to clear the state of the element
          // so that any future animations won't read the expired animation data.
          if (!isValidAnimation) {
            clearElementAnimationState(node);
          }

          return;
        }

        // this combined multiple class to addClass / removeClass into a setClass event
        // so long as a structural event did not take over the animation
        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
            ? 'setClass'
            : animationDetails.event;

        markElementAnimationState(node, RUNNING_STATE);
        var realRunner = $$animation(element, event, animationDetails.options);

        // this will update the runner's flow-control events based on
        // the `realRunner` object.
        runner.setHost(realRunner);
        notifyProgress(runner, event, 'start', getEventData(options));

        realRunner.done(function(status) {
          close(!status);
          var animationDetails = activeAnimationsLookup.get(node);
          if (animationDetails && animationDetails.counter === counter) {
            clearElementAnimationState(node);
          }
          notifyProgress(runner, event, 'close', getEventData(options));
        });
      });

      return runner;

      function notifyProgress(runner, event, phase, data) {
        runInNextPostDigestOrNow(function() {
          var callbacks = findCallbacks(parentNode, node, event);
          if (callbacks.length) {
            // do not optimize this call here to RAF because
            // we don't know how heavy the callback code here will
            // be and if this code is buffered then this can
            // lead to a performance regression.
            $$rAF(function() {
              forEach(callbacks, function(callback) {
                callback(element, phase, data);
              });
              cleanupEventListeners(phase, node);
            });
          } else {
            cleanupEventListeners(phase, node);
          }
        });
        runner.progress(event, phase, data);
      }

      function close(reject) {
        clearGeneratedClasses(element, options);
        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();
        runner.complete(!reject);
      }
    }

    function closeChildAnimations(node) {
      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
      forEach(children, function(child) {
        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
        var animationDetails = activeAnimationsLookup.get(child);
        if (animationDetails) {
          switch (state) {
            case RUNNING_STATE:
              animationDetails.runner.end();
              /* falls through */
            case PRE_DIGEST_STATE:
              activeAnimationsLookup.delete(child);
              break;
          }
        }
      });
    }

    function clearElementAnimationState(node) {
      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
      activeAnimationsLookup.delete(node);
    }

    /**
     * This fn returns false if any of the following is true:
     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
     * b) a parent element has an ongoing structural animation, and animateChildren is false
     * c) the element is not a child of the body
     * d) the element is not a child of the $rootElement
     */
    function areAnimationsAllowed(node, parentNode, event) {
      var bodyNode = $document[0].body;
      var rootNode = getDomNode($rootElement);

      var bodyNodeDetected = (node === bodyNode) || node.nodeName === 'HTML';
      var rootNodeDetected = (node === rootNode);
      var parentAnimationDetected = false;
      var elementDisabled = disabledElementsLookup.get(node);
      var animateChildren;

      var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
      if (parentHost) {
        parentNode = getDomNode(parentHost);
      }

      while (parentNode) {
        if (!rootNodeDetected) {
          // AngularJS doesn't want to attempt to animate elements outside of the application
          // therefore we need to ensure that the rootElement is an ancestor of the current element
          rootNodeDetected = (parentNode === rootNode);
        }

        if (parentNode.nodeType !== ELEMENT_NODE) {
          // no point in inspecting the #document element
          break;
        }

        var details = activeAnimationsLookup.get(parentNode) || {};
        // either an enter, leave or move animation will commence
        // therefore we can't allow any animations to take place
        // but if a parent animation is class-based then that's ok
        if (!parentAnimationDetected) {
          var parentNodeDisabled = disabledElementsLookup.get(parentNode);

          if (parentNodeDisabled === true && elementDisabled !== false) {
            // disable animations if the user hasn't explicitly enabled animations on the
            // current element
            elementDisabled = true;
            // element is disabled via parent element, no need to check anything else
            break;
          } else if (parentNodeDisabled === false) {
            elementDisabled = false;
          }
          parentAnimationDetected = details.structural;
        }

        if (isUndefined(animateChildren) || animateChildren === true) {
          var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
          if (isDefined(value)) {
            animateChildren = value;
          }
        }

        // there is no need to continue traversing at this point
        if (parentAnimationDetected && animateChildren === false) break;

        if (!bodyNodeDetected) {
          // we also need to ensure that the element is or will be a part of the body element
          // otherwise it is pointless to even issue an animation to be rendered
          bodyNodeDetected = (parentNode === bodyNode);
        }

        if (bodyNodeDetected && rootNodeDetected) {
          // If both body and root have been found, any other checks are pointless,
          // as no animation data should live outside the application
          break;
        }

        if (!rootNodeDetected) {
          // If `rootNode` is not detected, check if `parentNode` is pinned to another element
          parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
          if (parentHost) {
            // The pin target element becomes the next parent element
            parentNode = getDomNode(parentHost);
            continue;
          }
        }

        parentNode = parentNode.parentNode;
      }

      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
      return allowAnimation && rootNodeDetected && bodyNodeDetected;
    }

    function markElementAnimationState(node, state, details) {
      details = details || {};
      details.state = state;

      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);

      var oldValue = activeAnimationsLookup.get(node);
      var newValue = oldValue
          ? extend(oldValue, details)
          : details;
      activeAnimationsLookup.set(node, newValue);
    }
  }];
}];

/** @this */
var $$AnimateCacheProvider = function() {

  var KEY = '$$ngAnimateParentKey';
  var parentCounter = 0;
  var cache = Object.create(null);

  this.$get = [function() {
    return {
      cacheKey: function(node, method, addClass, removeClass) {
        var parentNode = node.parentNode;
        var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
        var parts = [parentID, method, node.getAttribute('class')];
        if (addClass) {
          parts.push(addClass);
        }
        if (removeClass) {
          parts.push(removeClass);
        }
        return parts.join(' ');
      },

      containsCachedAnimationWithoutDuration: function(key) {
        var entry = cache[key];

        // nothing cached, so go ahead and animate
        // otherwise it should be a valid animation
        return (entry && !entry.isValid) || false;
      },

      flush: function() {
        cache = Object.create(null);
      },

      count: function(key) {
        var entry = cache[key];
        return entry ? entry.total : 0;
      },

      get: function(key) {
        var entry = cache[key];
        return entry && entry.value;
      },

      put: function(key, value, isValid) {
        if (!cache[key]) {
          cache[key] = { total: 1, value: value, isValid: isValid };
        } else {
          cache[key].total++;
          cache[key].value = value;
        }
      }
    };
  }];
};

/* exported $$AnimationProvider */

var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';

  var drivers = this.drivers = [];

  var RUNNER_STORAGE_KEY = '$$animationRunner';
  var PREPARE_CLASSES_KEY = '$$animatePrepareClasses';

  function setRunner(element, runner) {
    element.data(RUNNER_STORAGE_KEY, runner);
  }

  function removeRunner(element) {
    element.removeData(RUNNER_STORAGE_KEY);
  }

  function getRunner(element) {
    return element.data(RUNNER_STORAGE_KEY);
  }

  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$Map', '$$rAFScheduler', '$$animateCache',
       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$Map,   $$rAFScheduler, $$animateCache) {

    var animationQueue = [];
    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function sortAnimations(animations) {
      var tree = { children: [] };
      var i, lookup = new $$Map();

      // this is done first beforehand so that the map
      // is filled with a list of the elements that will be animated
      for (i = 0; i < animations.length; i++) {
        var animation = animations[i];
        lookup.set(animation.domNode, animations[i] = {
          domNode: animation.domNode,
          element: animation.element,
          fn: animation.fn,
          children: []
        });
      }

      for (i = 0; i < animations.length; i++) {
        processNode(animations[i]);
      }

      return flatten(tree);

      function processNode(entry) {
        if (entry.processed) return entry;
        entry.processed = true;

        var elementNode = entry.domNode;
        var parentNode = elementNode.parentNode;
        lookup.set(elementNode, entry);

        var parentEntry;
        while (parentNode) {
          parentEntry = lookup.get(parentNode);
          if (parentEntry) {
            if (!parentEntry.processed) {
              parentEntry = processNode(parentEntry);
            }
            break;
          }
          parentNode = parentNode.parentNode;
        }

        (parentEntry || tree).children.push(entry);
        return entry;
      }

      function flatten(tree) {
        var result = [];
        var queue = [];
        var i;

        for (i = 0; i < tree.children.length; i++) {
          queue.push(tree.children[i]);
        }

        var remainingLevelEntries = queue.length;
        var nextLevelEntries = 0;
        var row = [];

        for (i = 0; i < queue.length; i++) {
          var entry = queue[i];
          if (remainingLevelEntries <= 0) {
            remainingLevelEntries = nextLevelEntries;
            nextLevelEntries = 0;
            result.push(row);
            row = [];
          }
          row.push(entry);
          entry.children.forEach(function(childEntry) {
            nextLevelEntries++;
            queue.push(childEntry);
          });
          remainingLevelEntries--;
        }

        if (row.length) {
          result.push(row);
        }

        return result;
      }
    }

    // TODO(matsko): document the signature in a better way
    return function(element, event, options) {
      options = prepareAnimationOptions(options);
      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      // there is no animation at the current moment, however
      // these runner methods will get later updated with the
      // methods leading into the driver's end/cancel methods
      // for now they just stop the animation from starting
      var runner = new $$AnimateRunner({
        end: function() { close(); },
        cancel: function() { close(true); }
      });

      if (!drivers.length) {
        close();
        return runner;
      }

      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
      var tempClasses = options.tempClasses;
      if (tempClasses) {
        classes += ' ' + tempClasses;
        options.tempClasses = null;
      }

      if (isStructural) {
        element.data(PREPARE_CLASSES_KEY, 'ng-' + event + PREPARE_CLASS_SUFFIX);
      }

      setRunner(element, runner);

      animationQueue.push({
        // this data is used by the postDigest code and passed into
        // the driver step function
        element: element,
        classes: classes,
        event: event,
        structural: isStructural,
        options: options,
        beforeStart: beforeStart,
        close: close
      });

      element.on('$destroy', handleDestroyedElement);

      // we only want there to be one function called within the post digest
      // block. This way we can group animations for all the animations that
      // were apart of the same postDigest flush call.
      if (animationQueue.length > 1) return runner;

      $rootScope.$$postDigest(function() {
        var animations = [];
        forEach(animationQueue, function(entry) {
          // the element was destroyed early on which removed the runner
          // form its storage. This means we can't animate this element
          // at all and it already has been closed due to destruction.
          if (getRunner(entry.element)) {
            animations.push(entry);
          } else {
            entry.close();
          }
        });

        // now any future animations will be in another postDigest
        animationQueue.length = 0;

        var groupedAnimations = groupAnimations(animations);
        var toBeSortedAnimations = [];

        forEach(groupedAnimations, function(animationEntry) {
          var element = animationEntry.from ? animationEntry.from.element : animationEntry.element;
          var extraClasses = options.addClass;

          extraClasses = (extraClasses ? (extraClasses + ' ') : '') + NG_ANIMATE_CLASSNAME;
          var cacheKey = $$animateCache.cacheKey(element[0], animationEntry.event, extraClasses, options.removeClass);

          toBeSortedAnimations.push({
            element: element,
            domNode: getDomNode(element),
            fn: function triggerAnimationStart() {
              var startAnimationFn, closeFn = animationEntry.close;

              // in the event that we've cached the animation status for this element
              // and it's in fact an invalid animation (something that has duration = 0)
              // then we should skip all the heavy work from here on
              if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
                closeFn();
                return;
              }

              // it's important that we apply the `ng-animate` CSS class and the
              // temporary classes before we do any driver invoking since these
              // CSS classes may be required for proper CSS detection.
              animationEntry.beforeStart();

              // in the event that the element was removed before the digest runs or
              // during the RAF sequencing then we should not trigger the animation.
              var targetElement = animationEntry.anchors
                  ? (animationEntry.from.element || animationEntry.to.element)
                  : animationEntry.element;

              if (getRunner(targetElement)) {
                var operation = invokeFirstDriver(animationEntry);
                if (operation) {
                  startAnimationFn = operation.start;
                }
              }

              if (!startAnimationFn) {
                closeFn();
              } else {
                var animationRunner = startAnimationFn();
                animationRunner.done(function(status) {
                  closeFn(!status);
                });
                updateAnimationRunners(animationEntry, animationRunner);
              }
            }
          });
        });

        // we need to sort each of the animations in order of parent to child
        // relationships. This ensures that the child classes are applied at the
        // right time.
        var finalAnimations = sortAnimations(toBeSortedAnimations);
        for (var i = 0; i < finalAnimations.length; i++) {
          var innerArray = finalAnimations[i];
          for (var j = 0; j < innerArray.length; j++) {
            var entry = innerArray[j];
            var element = entry.element;

            // the RAFScheduler code only uses functions
            finalAnimations[i][j] = entry.fn;

            // the first row of elements shouldn't have a prepare-class added to them
            // since the elements are at the top of the animation hierarchy and they
            // will be applied without a RAF having to pass...
            if (i === 0) {
              element.removeData(PREPARE_CLASSES_KEY);
              continue;
            }

            var prepareClassName = element.data(PREPARE_CLASSES_KEY);
            if (prepareClassName) {
              $$jqLite.addClass(element, prepareClassName);
            }
          }
        }

        $$rAFScheduler(finalAnimations);
      });

      return runner;

      // TODO(matsko): change to reference nodes
      function getAnchorNodes(node) {
        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
              ? [node]
              : node.querySelectorAll(SELECTOR);
        var anchors = [];
        forEach(items, function(node) {
          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
          if (attr && attr.length) {
            anchors.push(node);
          }
        });
        return anchors;
      }

      function groupAnimations(animations) {
        var preparedAnimations = [];
        var refLookup = {};
        forEach(animations, function(animation, index) {
          var element = animation.element;
          var node = getDomNode(element);
          var event = animation.event;
          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];

          if (anchorNodes.length) {
            var direction = enterOrMove ? 'to' : 'from';

            forEach(anchorNodes, function(anchor) {
              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
              refLookup[key] = refLookup[key] || {};
              refLookup[key][direction] = {
                animationID: index,
                element: jqLite(anchor)
              };
            });
          } else {
            preparedAnimations.push(animation);
          }
        });

        var usedIndicesLookup = {};
        var anchorGroups = {};
        forEach(refLookup, function(operations, key) {
          var from = operations.from;
          var to = operations.to;

          if (!from || !to) {
            // only one of these is set therefore we can't have an
            // anchor animation since all three pieces are required
            var index = from ? from.animationID : to.animationID;
            var indexKey = index.toString();
            if (!usedIndicesLookup[indexKey]) {
              usedIndicesLookup[indexKey] = true;
              preparedAnimations.push(animations[index]);
            }
            return;
          }

          var fromAnimation = animations[from.animationID];
          var toAnimation = animations[to.animationID];
          var lookupKey = from.animationID.toString();
          if (!anchorGroups[lookupKey]) {
            var group = anchorGroups[lookupKey] = {
              structural: true,
              beforeStart: function() {
                fromAnimation.beforeStart();
                toAnimation.beforeStart();
              },
              close: function() {
                fromAnimation.close();
                toAnimation.close();
              },
              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
              from: fromAnimation,
              to: toAnimation,
              anchors: [] // TODO(matsko): change to reference nodes
            };

            // the anchor animations require that the from and to elements both have at least
            // one shared CSS class which effectively marries the two elements together to use
            // the same animation driver and to properly sequence the anchor animation.
            if (group.classes.length) {
              preparedAnimations.push(group);
            } else {
              preparedAnimations.push(fromAnimation);
              preparedAnimations.push(toAnimation);
            }
          }

          anchorGroups[lookupKey].anchors.push({
            'out': from.element, 'in': to.element
          });
        });

        return preparedAnimations;
      }

      function cssClassesIntersection(a,b) {
        a = a.split(' ');
        b = b.split(' ');
        var matches = [];

        for (var i = 0; i < a.length; i++) {
          var aa = a[i];
          if (aa.substring(0,3) === 'ng-') continue;

          for (var j = 0; j < b.length; j++) {
            if (aa === b[j]) {
              matches.push(aa);
              break;
            }
          }
        }

        return matches.join(' ');
      }

      function invokeFirstDriver(animationDetails) {
        // we loop in reverse order since the more general drivers (like CSS and JS)
        // may attempt more elements, but custom drivers are more particular
        for (var i = drivers.length - 1; i >= 0; i--) {
          var driverName = drivers[i];
          var factory = $injector.get(driverName);
          var driver = factory(animationDetails);
          if (driver) {
            return driver;
          }
        }
      }

      function beforeStart() {
        tempClasses = (tempClasses ? (tempClasses + ' ') : '') + NG_ANIMATE_CLASSNAME;
        $$jqLite.addClass(element, tempClasses);

        var prepareClassName = element.data(PREPARE_CLASSES_KEY);
        if (prepareClassName) {
          $$jqLite.removeClass(element, prepareClassName);
          prepareClassName = null;
        }
      }

      function updateAnimationRunners(animation, newRunner) {
        if (animation.from && animation.to) {
          update(animation.from.element);
          update(animation.to.element);
        } else {
          update(animation.element);
        }

        function update(element) {
          var runner = getRunner(element);
          if (runner) runner.setHost(newRunner);
        }
      }

      function handleDestroyedElement() {
        var runner = getRunner(element);
        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
          runner.end();
        }
      }

      function close(rejected) {
        element.off('$destroy', handleDestroyedElement);
        removeRunner(element);

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();

        if (tempClasses) {
          $$jqLite.removeClass(element, tempClasses);
        }

        runner.complete(!rejected);
      }
    };
  }];
}];

/**
 * @ngdoc directive
 * @name ngAnimateSwap
 * @restrict A
 * @scope
 *
 * @description
 *
 * ngAnimateSwap is a animation-oriented directive that allows for the container to
 * be removed and entered in whenever the associated expression changes. A
 * common usecase for this directive is a rotating banner or slider component which
 * contains one image being present at a time. When the active image changes
 * then the old image will perform a `leave` animation and the new element
 * will be inserted via an `enter` animation.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|--------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
 *
 * @example
 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
 *          deps="angular-animate.js"
 *          animations="true" fixBase="true">
 *   <file name="index.html">
 *     <div class="container" ng-controller="AppCtrl">
 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
 *         {{ number }}
 *       </div>
 *     </div>
 *   </file>
 *   <file name="script.js">
 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
 *         $scope.number = 0;
 *         $interval(function() {
 *           $scope.number++;
 *         }, 1000);
 *
 *         var colors = ['red','blue','green','yellow','orange'];
 *         $scope.colorClass = function(number) {
 *           return colors[number % colors.length];
 *         };
 *       }]);
 *   </file>
 *  <file name="animations.css">
 *  .container {
 *    height:250px;
 *    width:250px;
 *    position:relative;
 *    overflow:hidden;
 *    border:2px solid black;
 *  }
 *  .container .cell {
 *    font-size:150px;
 *    text-align:center;
 *    line-height:250px;
 *    position:absolute;
 *    top:0;
 *    left:0;
 *    right:0;
 *    border-bottom:2px solid black;
 *  }
 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
 *    transition:0.5s linear all;
 *  }
 *  .swap-animation.ng-enter {
 *    top:-250px;
 *  }
 *  .swap-animation.ng-enter-active {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave-active {
 *    top:250px;
 *  }
 *  .red { background:red; }
 *  .green { background:green; }
 *  .blue { background:blue; }
 *  .yellow { background:yellow; }
 *  .orange { background:orange; }
 *  </file>
 * </example>
 */
var ngAnimateSwapDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    transclude: 'element',
    terminal: true,
    priority: 550, // We use 550 here to ensure that the directive is caught before others,
                   // but after `ngIf` (at priority 600).
    link: function(scope, $element, attrs, ctrl, $transclude) {
      var previousElement, previousScope;
      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
        if (previousElement) {
          $animate.leave(previousElement);
        }
        if (previousScope) {
          previousScope.$destroy();
          previousScope = null;
        }
        if (value || value === 0) {
          $transclude(function(clone, childScope) {
            previousElement = clone;
            previousScope = childScope;
            $animate.enter(clone, null, $element);
          });
        }
      });
    }
  };
}];

/**
 * @ngdoc module
 * @name ngAnimate
 * @description
 *
 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an AngularJS app.
 *
 * ## Usage
 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
 * the HTML element that the animation will be triggered on.
 *
 * ## Directive Support
 * The following directives are "animation aware":
 *
 * | Directive                                                                     | Supported Animations                                                      |
 * |-------------------------------------------------------------------------------|---------------------------------------------------------------------------|
 * | {@link ng.directive:form#animations form / ngForm}                            | add and remove ({@link ng.directive:form#css-classes various classes})    |
 * | {@link ngAnimate.directive:ngAnimateSwap#animations ngAnimateSwap}            | enter and leave                                                           |
 * | {@link ng.directive:ngClass#animations ngClass / {{class&#125;&#8203;&#125;}  | add and remove                                                            |
 * | {@link ng.directive:ngClassEven#animations ngClassEven}                       | add and remove                                                            |
 * | {@link ng.directive:ngClassOdd#animations ngClassOdd}                         | add and remove                                                            |
 * | {@link ng.directive:ngHide#animations ngHide}                                 | add and remove (the `ng-hide` class)                                      |
 * | {@link ng.directive:ngIf#animations ngIf}                                     | enter and leave                                                           |
 * | {@link ng.directive:ngInclude#animations ngInclude}                           | enter and leave                                                           |
 * | {@link module:ngMessages#animations ngMessage / ngMessageExp}                 | enter and leave                                                           |
 * | {@link module:ngMessages#animations ngMessages}                               | add and remove (the `ng-active`/`ng-inactive` classes)                    |
 * | {@link ng.directive:ngModel#animations ngModel}                               | add and remove ({@link ng.directive:ngModel#css-classes various classes}) |
 * | {@link ng.directive:ngRepeat#animations ngRepeat}                             | enter, leave, and move                                                    |
 * | {@link ng.directive:ngShow#animations ngShow}                                 | add and remove (the `ng-hide` class)                                      |
 * | {@link ng.directive:ngSwitch#animations ngSwitch}                             | enter and leave                                                           |
 * | {@link ngRoute.directive:ngView#animations ngView}                            | enter and leave                                                           |
 *
 * (More information can be found by visiting the documentation associated with each directive.)
 *
 * For a full breakdown of the steps involved during each animation event, refer to the
 * {@link ng.$animate `$animate` API docs}.
 *
 * ## CSS-based Animations
 *
 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
 * and CSS code we can create an animation that will be picked up by AngularJS when an underlying directive performs an operation.
 *
 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
 *
 * ```html
 * <div ng-if="bool" class="fade">
 *    Fade me in out
 * </div>
 * <button ng-click="bool=true">Fade In!</button>
 * <button ng-click="bool=false">Fade Out!</button>
 * ```
 *
 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
 *
 * ```css
 * /&#42; The starting CSS styles for the enter animation &#42;/
 * .fade.ng-enter {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 *
 * /&#42; The finishing CSS styles for the enter animation &#42;/
 * .fade.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * ```
 *
 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
 *
 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
 *
 * ```css
 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
 * .fade.ng-leave {
 *   transition:0.5s linear all;
 *   opacity:1;
 * }
 * .fade.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
 *
 * ```css
 * /&#42; there is no need to define anything inside of the destination
 * CSS class since the keyframe will take charge of the animation &#42;/
 * .fade.ng-leave {
 *   animation: my_fade_animation 0.5s linear;
 *   -webkit-animation: my_fade_animation 0.5s linear;
 * }
 *
 * @keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 *
 * @-webkit-keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 * ```
 *
 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
 *
 * ### CSS Class-based Animations
 *
 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
 * and removed.
 *
 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
 *
 * ```html
 * <div ng-show="bool" class="fade">
 *   Show and hide me
 * </div>
 * <button ng-click="bool=!bool">Toggle</button>
 *
 * <style>
 * .fade.ng-hide {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 * </style>
 * ```
 *
 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
 *
 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
 * with CSS styles.
 *
 * ```html
 * <div ng-class="{on:onOff}" class="highlight">
 *   Highlight this box
 * </div>
 * <button ng-click="onOff=!onOff">Toggle</button>
 *
 * <style>
 * .highlight {
 *   transition:0.5s linear all;
 * }
 * .highlight.on-add {
 *   background:white;
 * }
 * .highlight.on {
 *   background:yellow;
 * }
 * .highlight.on-remove {
 *   background:black;
 * }
 * </style>
 * ```
 *
 * We can also make use of CSS keyframes by placing them within the CSS classes.
 *
 *
 * ### CSS Staggering Animations
 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
 *
 * ```css
 * .my-animation.ng-enter {
 *   /&#42; standard transition code &#42;/
 *   transition: 1s linear all;
 *   opacity:0;
 * }
 * .my-animation.ng-enter-stagger {
 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
 *   transition-delay: 0.1s;
 *
 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
 *     to not accidentally inherit a delay property from another CSS class &#42;/
 *   transition-duration: 0s;
 *
 *   /&#42; if you are using animations instead of transitions you should configure as follows:
 *     animation-delay: 0.1s;
 *     animation-duration: 0s; &#42;/
 * }
 * .my-animation.ng-enter.ng-enter-active {
 *   /&#42; standard transition styles &#42;/
 *   opacity:1;
 * }
 * ```
 *
 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
 *
 * The following code will issue the **ng-leave-stagger** event on the element provided:
 *
 * ```js
 * var kids = parent.children();
 *
 * $animate.leave(kids[0]); //stagger index=0
 * $animate.leave(kids[1]); //stagger index=1
 * $animate.leave(kids[2]); //stagger index=2
 * $animate.leave(kids[3]); //stagger index=3
 * $animate.leave(kids[4]); //stagger index=4
 *
 * window.requestAnimationFrame(function() {
 *   //stagger has reset itself
 *   $animate.leave(kids[5]); //stagger index=0
 *   $animate.leave(kids[6]); //stagger index=1
 *
 *   $scope.$digest();
 * });
 * ```
 *
 * Stagger animations are currently only supported within CSS-defined animations.
 *
 * ### The `ng-animate` CSS class
 *
 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
 *
 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
 *
 * ```css
 * .zipper.ng-animate {
 *   transition:0.5s linear all;
 * }
 * .zipper.ng-enter {
 *   opacity:0;
 * }
 * .zipper.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * .zipper.ng-leave {
 *   opacity:1;
 * }
 * .zipper.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
 * the CSS class once an animation has completed.)
 *
 *
 * ### The `ng-[event]-prepare` class
 *
 * This is a special class that can be used to prevent unwanted flickering / flash of content before
 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
 * before the actual animation starts (after waiting for a $digest).
 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
 *
 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
 * into elements that have class-based animations such as `ngClass`.
 *
 * ```html
 * <div ng-class="{red: myProp}">
 *   <div ng-class="{blue: myProp}">
 *     <div class="message" ng-if="myProp"></div>
 *   </div>
 * </div>
 * ```
 *
 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
 *
 * ```css
 * .message.ng-enter-prepare {
 *   opacity: 0;
 * }
 * ```
 *
 * ### Animating between value changes
 *
 * Sometimes you need to animate between different expression states, whose values
 * don't necessary need to be known or referenced in CSS styles.
 * Unless possible with another {@link ngAnimate#directive-support "animation aware" directive},
 * that specific use case can always be covered with {@link ngAnimate.directive:ngAnimateSwap} as
 * can be seen in {@link ngAnimate.directive:ngAnimateSwap#examples this example}.
 *
 * Note that {@link ngAnimate.directive:ngAnimateSwap} is a *structural directive*, which means it
 * creates a new instance of the element (including any other/child directives it may have) and
 * links it to a new scope every time *swap* happens. In some cases this might not be desirable
 * (e.g. for performance reasons, or when you wish to retain internal state on the original
 * element instance).
 *
 * ## JavaScript-based Animations
 *
 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
 * `module.animation()` module function we can register the animation.
 *
 * Let's see an example of a enter/leave animation using `ngRepeat`:
 *
 * ```html
 * <div ng-repeat="item in items" class="slide">
 *   {{ item }}
 * </div>
 * ```
 *
 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     // make note that other events (like addClass/removeClass)
 *     // have different function input parameters
 *     enter: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *
 *       // remember to call doneFn so that AngularJS
 *       // knows that the animation has concluded
 *     },
 *
 *     move: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *     },
 *
 *     leave: function(element, doneFn) {
 *       jQuery(element).fadeOut(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
 * greensock.js and velocity.js.
 *
 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
 *
 * ```html
 * <div ng-class="color" class="colorful">
 *   this box is moody
 * </div>
 * <button ng-click="color='red'">Change to red</button>
 * <button ng-click="color='blue'">Change to blue</button>
 * <button ng-click="color='green'">Change to green</button>
 * ```
 *
 * ```js
 * myModule.animation('.colorful', [function() {
 *   return {
 *     addClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     removeClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     setClass: function(element, addedClass, removedClass, doneFn) {
 *       // do some cool animation and call the doneFn
 *     }
 *   }
 * }]);
 * ```
 *
 * ## CSS + JS Animations Together
 *
 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of AngularJS,
 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
 * charge of the animation**:
 *
 * ```html
 * <div ng-if="bool" class="slide">
 *   Slide in and out
 * </div>
 * ```
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     enter: function(element, doneFn) {
 *       jQuery(element).slideIn(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * ```css
 * .slide.ng-enter {
 *   transition:0.5s linear all;
 *   transform:translateY(-100px);
 * }
 * .slide.ng-enter.ng-enter-active {
 *   transform:translateY(0);
 * }
 * ```
 *
 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
 * our own JS-based animation code:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
 *
 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
 * data into `$animateCss` directly:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true,
 *         addClass: 'maroon-setting',
 *         from: { height:0 },
 *         to: { height: 200 }
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Now we can fill in the rest via our transition CSS code:
 *
 * ```css
 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
 * .slide.ng-enter { transition:0.5s linear all; }
 *
 * /&#42; this extra CSS class will be absorbed into the transition
 * since the $animateCss code is adding the class &#42;/
 * .maroon-setting { background:red; }
 * ```
 *
 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
 *
 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
 *
 * ## Animation Anchoring (via `ng-animate-ref`)
 *
 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
 * structural areas of an application (like views) by pairing up elements using an attribute
 * called `ng-animate-ref`.
 *
 * Let's say for example we have two views that are managed by `ng-view` and we want to show
 * that there is a relationship between two components situated in within these views. By using the
 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
 * can then attach an animation, which is triggered when the view changes.
 *
 * Say for example we have the following template code:
 *
 * ```html
 * <!-- index.html -->
 * <div ng-view class="view-animation">
 * </div>
 *
 * <!-- home.html -->
 * <a href="#/banner-page">
 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * </a>
 *
 * <!-- banner-page.html -->
 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * ```
 *
 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
 * HTML contents to see if there is a match reference between any components in the view
 * that is leaving and the view that is entering. It will scan both the view which is being
 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
 * contain a matching ref value.
 *
 * The two images match since they share the same ref value. ngAnimate will now create a
 * transport element (which is a clone of the first image element) and it will then attempt
 * to animate to the position of the second image element in the next view. For the animation to
 * work a special CSS class called `ng-anchor` will be added to the transported element.
 *
 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
 * ngAnimate will handle the entire transition for us as well as the addition and removal of
 * any changes of CSS classes between the elements:
 *
 * ```css
 * .banner.ng-anchor {
 *   /&#42; this animation will last for 1 second since there are
 *          two phases to the animation (an `in` and an `out` phase) &#42;/
 *   transition:0.5s linear all;
 * }
 * ```
 *
 * We also **must** include animations for the views that are being entered and removed
 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
 *
 * ```css
 * .view-animation.ng-enter, .view-animation.ng-leave {
 *   transition:0.5s linear all;
 *   position:fixed;
 *   left:0;
 *   top:0;
 *   width:100%;
 * }
 * .view-animation.ng-enter {
 *   transform:translateX(100%);
 * }
 * .view-animation.ng-leave,
 * .view-animation.ng-enter.ng-enter-active {
 *   transform:translateX(0%);
 * }
 * .view-animation.ng-leave.ng-leave-active {
 *   transform:translateX(-100%);
 * }
 * ```
 *
 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
 * from its origin. Once that animation is over then the `in` stage occurs which animates the
 * element to its destination. The reason why there are two animations is to give enough time
 * for the enter animation on the new element to be ready.
 *
 * The example above sets up a transition for both the in and out phases, but we can also target the out or
 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
 *
 * ```css
 * .banner.ng-anchor-out {
 *   transition: 0.5s linear all;
 *
 *   /&#42; the scale will be applied during the out animation,
 *          but will be animated away when the in animation runs &#42;/
 *   transform: scale(1.2);
 * }
 *
 * .banner.ng-anchor-in {
 *   transition: 1s linear all;
 * }
 * ```
 *
 *
 *
 *
 * ### Anchoring Demo
 *
  <example module="anchoringExample"
           name="anchoringExample"
           id="anchoringExample"
           deps="angular-animate.js;angular-route.js"
           animations="true">
    <file name="index.html">
      <a href="#!/">Home</a>
      <hr />
      <div class="view-container">
        <div ng-view class="view"></div>
      </div>
    </file>
    <file name="script.js">
      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
        .config(['$routeProvider', function($routeProvider) {
          $routeProvider.when('/', {
            templateUrl: 'home.html',
            controller: 'HomeController as home'
          });
          $routeProvider.when('/profile/:id', {
            templateUrl: 'profile.html',
            controller: 'ProfileController as profile'
          });
        }])
        .run(['$rootScope', function($rootScope) {
          $rootScope.records = [
            { id: 1, title: 'Miss Beulah Roob' },
            { id: 2, title: 'Trent Morissette' },
            { id: 3, title: 'Miss Ava Pouros' },
            { id: 4, title: 'Rod Pouros' },
            { id: 5, title: 'Abdul Rice' },
            { id: 6, title: 'Laurie Rutherford Sr.' },
            { id: 7, title: 'Nakia McLaughlin' },
            { id: 8, title: 'Jordon Blanda DVM' },
            { id: 9, title: 'Rhoda Hand' },
            { id: 10, title: 'Alexandrea Sauer' }
          ];
        }])
        .controller('HomeController', [function() {
          //empty
        }])
        .controller('ProfileController', ['$rootScope', '$routeParams',
            function ProfileController($rootScope, $routeParams) {
          var index = parseInt($routeParams.id, 10);
          var record = $rootScope.records[index - 1];

          this.title = record.title;
          this.id = record.id;
        }]);
    </file>
    <file name="home.html">
      <h2>Welcome to the home page</h1>
      <p>Please click on an element</p>
      <a class="record"
         ng-href="#!/profile/{{ record.id }}"
         ng-animate-ref="{{ record.id }}"
         ng-repeat="record in records">
        {{ record.title }}
      </a>
    </file>
    <file name="profile.html">
      <div class="profile record" ng-animate-ref="{{ profile.id }}">
        {{ profile.title }}
      </div>
    </file>
    <file name="animations.css">
      .record {
        display:block;
        font-size:20px;
      }
      .profile {
        background:black;
        color:white;
        font-size:100px;
      }
      .view-container {
        position:relative;
      }
      .view-container > .view.ng-animate {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        min-height:500px;
      }
      .view.ng-enter, .view.ng-leave,
      .record.ng-anchor {
        transition:0.5s linear all;
      }
      .view.ng-enter {
        transform:translateX(100%);
      }
      .view.ng-enter.ng-enter-active, .view.ng-leave {
        transform:translateX(0%);
      }
      .view.ng-leave.ng-leave-active {
        transform:translateX(-100%);
      }
      .record.ng-anchor-out {
        background:red;
      }
    </file>
  </example>
 *
 * ### How is the element transported?
 *
 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
 * will become visible since the shim class will be removed.
 *
 * ### How is the morphing handled?
 *
 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
 * what CSS classes differ between the starting element and the destination element. These different CSS classes
 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
 * the cloned element is placed inside of root element which is likely close to the body element).
 *
 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
 *
 *
 * ## Using $animate in your directive code
 *
 * So far we've explored how to feed in animations into an AngularJS application, but how do we trigger animations within our own directives in our application?
 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
 * imagine we have a greeting box that shows and hides itself when the data changes
 *
 * ```html
 * <greeting-box active="onOrOff">Hi there</greeting-box>
 * ```
 *
 * ```js
 * ngModule.directive('greetingBox', ['$animate', function($animate) {
 *   return function(scope, element, attrs) {
 *     attrs.$observe('active', function(value) {
 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
 *     });
 *   });
 * }]);
 * ```
 *
 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
 * in our HTML code then we can trigger a CSS or JS animation to happen.
 *
 * ```css
 * /&#42; normally we would create a CSS class to reference on the element &#42;/
 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
 * ```
 *
 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
 * possible be sure to visit the {@link ng.$animate $animate service API page}.
 *
 *
 * ## Callbacks and Promises
 *
 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
 * ended by chaining onto the returned promise that animation method returns.
 *
 * ```js
 * // somewhere within the depths of the directive
 * $animate.enter(element, parent).then(function() {
 *   //the animation has completed
 * });
 * ```
 *
 * (Note that earlier versions of AngularJS prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
 * anymore.)
 *
 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
 * routing controller to hook into that:
 *
 * ```js
 * ngModule.controller('HomePageController', ['$animate', function($animate) {
 *   $animate.on('enter', ngViewElement, function(element) {
 *     // the animation for this route has completed
 *   }]);
 * }])
 * ```
 *
 * (Note that you will need to trigger a digest within the callback to get AngularJS to notice any scope-related changes.)
 */

var copy;
var extend;
var forEach;
var isArray;
var isDefined;
var isElement;
var isFunction;
var isObject;
var isString;
var isUndefined;
var jqLite;
var noop;

/**
 * @ngdoc service
 * @name $animate
 * @kind object
 *
 * @description
 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
 *
 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
 */
angular.module('ngAnimate', [], function initAngularHelpers() {
  // Access helpers from AngularJS core.
  // Do it inside a `config` block to ensure `window.angular` is available.
  noop        = angular.noop;
  copy        = angular.copy;
  extend      = angular.extend;
  jqLite      = angular.element;
  forEach     = angular.forEach;
  isArray     = angular.isArray;
  isString    = angular.isString;
  isObject    = angular.isObject;
  isUndefined = angular.isUndefined;
  isDefined   = angular.isDefined;
  isFunction  = angular.isFunction;
  isElement   = angular.isElement;
})
  .info({ angularVersion: '1.8.3' })
  .directive('ngAnimateSwap', ngAnimateSwapDirective)

  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
  .factory('$$rAFScheduler', $$rAFSchedulerFactory)

  .provider('$$animateQueue', $$AnimateQueueProvider)
  .provider('$$animateCache', $$AnimateCacheProvider)
  .provider('$$animation', $$AnimationProvider)

  .provider('$animateCss', $AnimateCssProvider)
  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)

  .provider('$$animateJs', $$AnimateJsProvider)
  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);


})(window, window.angular);


/***/ }),

/***/ "zApV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"goal-step":"goal-step","subtitle":"subtitle","options":"options","option":"option","option-text":"option-text","selected":"selected","btn-primary":"btn-primary"};

/***/ }),

/***/ "zeJd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"header","header-logo":"header-logo","button-toggle-navigation":"button-toggle-navigation","navigation-container":"navigation-container","navigation":"navigation","visible":"visible","navigation-items":"navigation-items","navigation-item":"navigation-item","navigation-link":"navigation-link","navigation-link-sign-up":"navigation-link-sign-up","navigation-button-sign-up":"navigation-button-sign-up"};

/***/ })

},[0]);


// WEBPACK FOOTER //
// asset/script-presentation-2751cecbf475d6733287.bundle.js